import React, { Component, createRef } from 'react';
import { Link } from 'react-router-dom';
/**
 * Ref: LN_PC_02
 * Importing the action and store file and set to an object.
 */
import * as HomepageAction from '../actions/HomepageAction'
import * as MenuAction from '../actions/MenuAction'
import HomepageStore from '../stores/HomepageStore'
import * as CookieService from '../CookieService';
import { RotatingLines } from 'react-loader-spinner';
import Autocomplete from 'react-autocomplete';
import SDIConstants, { ConvertToEst } from '../SDIConstants';

import * as $ from 'jquery';
//import { Translator, Translate } from 'react-auto-translate';
import { withTranslation, Trans } from 'react-i18next'
import { Redirect } from 'react-router-dom';
import i18n from '../i18n';
import swal from 'sweetalert';

//********NEW*********wal-158*
import Select from 'react-select';
import { fontSize } from '@material-ui/system';
let catcount = 0;
let suppcount = 0;
let mfgcount = 0;
let files = ""
let CategoryPresent = false; //WW-633_PC_01 (2/24/2023) -Aparna
let supplierPresent = false;
let IsImageSearch = false;
//******END**************
let currentPath = "";
const cacheProvider = {
    get: (language, key) =>
        ((JSON.parse(localStorage.getItem('translations')) || {})[key] || {})[
        language
        ],
    set: (language, key, value) => {
        const existing = JSON.parse(localStorage.getItem('translations')) || {
            [key]: {},
        };
        existing[key] = { ...existing[key], [language]: value };
        localStorage.setItem('translations', JSON.stringify(existing));
    },
};
class HomePageComponent extends Component {
    _isMounted = false;
    /**
   * Ref: LN_PC_04
   * Define the constructor that takes props as parameter
   * 
   * @param props
   */
    constructor(props) {
        super(props);
        this.userIDInput = React.createRef();
        this.inputRef = React.createRef();   // WW - 5610 - create a useRef for Search input field [4/10/2025] - Nachiappan
        //  this.handleLoginChange = this.handleLoginChange.bind(this);
        this.assignPageLoad = this.assignPageLoad.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.searchClick = this.searchClick.bind(this);
        this.getItemValue = this.getItemValue.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.searchKeyPress = this.searchKeyPress.bind(this);
        //  this.loadAttachmentsImg = this.loadAttachmentsImg.bind(this);
        this.referenceSiteChange = this.referenceSiteChange.bind(this);
        this.referenceSiteNavigation = this.referenceSiteNavigation.bind(this);
        this.PassThroughAutheResponse = this.PassThroughAutheResponse.bind(this);//***NEW*wal-158****
        this.fileInputRef = React.createRef();
        // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
        this.wrapperRef = createRef();
        this.noncatClick = this.noncatClick.bind(this);
        this.noncat = this.noncat.bind(this);
        this.WorkOrderResponse = this.WorkOrderResponse.bind(this);
        //WW-1229 Home tiles -Nandhini L
        this.BindHomeTiles = this.BindHomeTiles.bind(this);
        this.onClickHomeTiles = this.onClickHomeTiles.bind(this);
        this.fetchPrefilterDataResponse = this.fetchPrefilterDataResponse.bind(this);
        this.fetchPrefilterData = this.fetchPrefilterData.bind(this);
        //WW-1374 Problem code search - Nandhini L 
        this.onChangePC = this.onChangePC.bind(this);
        this.PcPopupBtnClick = this.PcPopupBtnClick.bind(this)

        /**
        * Ref: LN_PC_05
        * Set the initial values of the state variables
        */
        this.state = {
            NonCatalogVisible: false,
            PunchoutVisible: false,
            strCplusitemid: "0",
            ItemDate: "",
            requestorApprovalCount: 0, catcnt: false, supcnt: false,
            txtItemID: "", selectallCat: true, selectallSup: true, selectallMfg: true, //WW-633_PC_02 (2/24/2023) -Aparna
            Login_UserId: (CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID")),
            Login_UserBU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
            FrontEndFlags: [],
            ExternalSiteList: [],
            TradeCatalogList: [],
            autocompleteData: [],
            // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
            productData: [],
            suggestionData: [],
            autoCompleteValue: "",
            referenceSite: "",
            RefsiteOptions: [],
            siteName: "Reference Site",
            viewcat: false,
            oldlang: "",
            IsPartList: false,
            language: "",
            viewsup: false,
            viewmfg: false,
            PFCategory: localStorage.getItem("PFCategory") == null ? [] : JSON.parse(localStorage.getItem("PFCategory")), PFManufacturer: [], PFSupplier: localStorage.getItem("PFSupplier") == null ? [] : JSON.parse(localStorage.getItem("PFSupplier")), PFPartlist: [], CompletePartList: [], isHelPAccess: false,
            OrderStatusVisible: false, SupplierCallInVisible: false, RequestrApprovalVisible: false, TechVaultVisible: false, TechHubVisible: false, isAssetDDDisable: false, InteractiveImagesVisible: false,
            Make: "0", Model: "0", AssetID: "0", MakeList: [], ModelList: [], AssetList: [], DefaultAsset: "", getMFG: "", catORsupp: "", pickupcheck: false, inventorycheck: false, techHubURL: "",WOErrorMsg: "",
            MFGchecked: localStorage.getItem("PFMFG") == null ? [] : JSON.parse(localStorage.getItem("PFMFG")), Pickup_VendorList: [], catsearch: "", supsearch: "",//***NEW******wal-158***
            pickUp: false, deliveryShipTo: true, ViewMfgList: CookieService.getLocalStorageValues("PFMFG") != null && CookieService.getLocalStorageValues("PFMFG") != undefined ? CookieService.getLocalStorageValues("PFMFG") : [], MFGArray: [], MFGSelectedCount: CookieService.getLocalStorageValues("PFMFGCount") > 0 ? CookieService.getLocalStorageValues("PFMFGCount") : 0,
            //WW-1229 Home tiles -Nandhini L
            UserTiles: [], Type: "",
            displayText: "",
            isRedirect: false,
            resultMessage: "",
            // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
            elementIsShow: false,
            shipmentmethoderrorid: "",
            SearchType: CookieService.getLocalStorageValues("SearchType") ? CookieService.getLocalStorageValues("SearchType") : "All",
            WONum: localStorage.getItem("WONum") ? localStorage.getItem("WONum") : "",
            IsProblemCodeSearch: false

        }
    }



    componentDidMount() {


        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        //console.log("window", window.location.pathname);
        navigator.geolocation.getCurrentPosition(function (position) {
        });
        let HomepageBO = {

            //Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            //Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            //Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            //Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            //Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME"),
            //Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),

            Session_Cart: '',
            Session_AttrbuteName: '',
            Session_CategoryID: '',
            Session_ClassID: '',
            Session_FAMILYID: '',
            Session_LastRecord: '',
            Session_Minimize: '',
            Session_PageSize: '',
            Session_ParentID: '',
            Session_SCREENNAME: '',
            Session_SEGMENTID: '',
            Session_SkipBread: '',
            Session_TermsnConditionsAccept: 'Y',
            Session_UnClass: '',
            UserID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_xmlData: '',
            Session_xmlToUrl: '',
            Session_SITE_CONTACTS: '',
            Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
            Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
            BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_PRODVIEW: CookieService.getLocalStorageValues("Session_PRODVIEW"),
            Session_PROD_DESCPREFERENCE: CookieService.getLocalStorageValues("Session_PROD_DESCPREFERENCE"),
            cplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEBU: CookieService.getLocalStorageValues("Session_SITEBU"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CATLTREEHLDFLAG: CookieService.getLocalStorageValues("Session_CATLTREEHLDFLAG"),
            SHOPPAGE: CookieService.getLocalStorageValues("Session_SHOPPAGE"),
            Session_ZEUSNOCATALOGSITE: CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE"),
            SDIEmp: CookieService.getLocalStorageValues("Session_SDIEMP"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            m_siteCurrency: '',
            Session_SiteLang: '',
            Session_TrackingNumber: '',
            Session_ShipToID: '',
            Login_UserBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            WorkOrderPnchInA: CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") ? CookieService.getLocalStorageValues("Session_WorkOrderPnchInA") : "",
            SystemCode: 'WALW'

        }

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        let currentPagePath = this.props.location.pathname;
        if (currentPagePath != "/shoppingcart") {
            HomepageAction.pageLoad(HomepageBO);
        }
        /**
        * Ref: LN_PC_07
        * Define the listener methods
        */
        HomepageStore.on('load', this.assignPageLoad);
        /****NEW******wal-158*/
        if (localStorage.getItem("PFCatCount") != null) {
            catcount = JSON.parse(localStorage.getItem("PFCatCount"));
        }
        let CatArray = localStorage.getItem("PFCategory");
        if (catcount == 0) {
            this.setState({ selectallCat: true });
        }
        else if (catcount != CatArray.length) {
            this.setState({ selectallCat: true });
        }
        else {
            this.setState({ selectallCat: false });
        }

        if (localStorage.getItem("PFSuppCount") != null) {
            suppcount = JSON.parse(localStorage.getItem("PFSuppCount"));
        }
        if (suppcount == 0)
            this.setState({ selectallSup: true });
        else
            this.setState({ selectallSup: false });
        //if (localStorage.getItem("PFMFGCount") != null) {
        //    suppcount = JSON.parse(localStorage.getItem("PFMFGCount"));
        //}


        $(`#modelid`).prop('disabled', true)
        HomepageStore.on('MFG', this.assignMFG);
        HomepageStore.on('PassThroughAuthe', this.PassThroughAutheResponse.bind(this));
        /*[08/31/22 , PC_365_13]Tech Vault Search - Priyanka D*/
        HomepageStore.on('TechVault', this.TechVaultResponse);
        HomepageStore.on('workordercheckresponse', this.WorkOrderResponse);
        HomepageStore.on('WOfail', this.WorkOrderFail);
        HomepageStore.on('preFilter', this.fetchPrefilterDataResponse);
        // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
        document.addEventListener('mousedown', this.handleClickOutside);
        //  NonCatalogStore.on('attachmentResponse', this.loadAttachmentsImg);
        //*****END******

    }
    componentWillUnmount() {
        // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
        document.removeEventListener('mousedown', this.handleClickOutside);
        HomepageStore.removeListener('PassThroughAuthe', this.PassThroughAutheResponse);
        HomepageStore.removeListener('load', this.assignPageLoad);
        HomepageStore.removeListener('MFG', this.assignMFG);
        HomepageStore.removeListener('TechVault', this.TechVaultResponse);
        HomepageStore.removeListener('workordercheckresponse', this.WorkOrderResponse);
        HomepageStore.removeListener('WOfail', this.WorkOrderFail);
        HomepageStore.removeListener('preFilter', this.fetchPrefilterDataResponse);
        //NonCatalogStore.removeListener('attachmentResponse', this.loadAttachmentsImg);
        //localStorage.setItem("PFMFGCount", this.state.MFGSelectedCount);
        //localStorage.setItem("PFMFGCount", this.state.ViewMfgList);
        CookieService.updateLocalStorageValues("PFMFGCount", this.state.MFGSelectedCount)
        CookieService.updateLocalStorageValues("PFMFG", this.state.ViewMfgList)
        console.log("mfglistcookie", CookieService.getLocalStorageValues("PFMFG"))
    }
    // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
    handleClickOutside = (event) => {
        if (this.wrapperRef.current && (!this.wrapperRef.current.contains(event.target) || event ?.target ?.id == "filterButton")) {
            this.setState({ elementIsShow: false })
        }
    };
    handleShowElement = () => {
        this.setState({ elementIsShow: true })
    }
    bindRefsiteDD = (ExternalSiteList) => {

        let RefSiteDDvalue = []
        if (ExternalSiteList.length > 0) {
            ExternalSiteList.map((val, index) => {
                let localArray = {
                    value: val.SITE_URL,
                    label: val.SITE_DESC,
                }
                RefSiteDDvalue.push(localArray)
            });
            this.setState({ RefsiteOptions: RefSiteDDvalue });
        }
    }

    TechVault = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let techVaultBO = {
            //[01/30/2024, WW-942] open tech vault without search value - Nandhini L
            //AssetID: localStorage.getItem("WOAssetID"),
            //Tradename: CookieService.getLocalStorageValues("Trade"),
            AssetID: "",
            Tradename: "",
            WO_Type: CookieService.getLocalStorageValues("WO_Type")
        }
        HomepageAction.TechVault(techVaultBO)
    }

    TechVaultResponse = () => {

        let TechVaultResponse = JSON.parse(HomepageStore.TechVault);
        let ErrorMessage = TechVaultResponse.ErrorMessage;
        if (ErrorMessage != undefined) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI Customer Care"
            });
            //alert("Technical Issue. Please contact SDI Customer Care")
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        } else {
            //let Assetdetails = TechVaultResponse.AssetDetails;
            //let Category = TechVaultResponse.Category;
            let Tech_Token = TechVaultResponse.Token[0].token;
            //let AssetID = CookieService.getLocalStorageValues("AssetID")
            //let Trade = CookieService.getLocalStorageValues("Trade")

            //[02/07/2024, BUG 4700] open tech vault without search value - Nandhini L
            let Assetdetails = "";
            let Category = "";
            // let Tech_Token = "";
            let AssetID = "";
            let Trade = "";
            if (Category != undefined && Category != null && Category != "" && Category != " ") {
                if (Category[0].DESCR != null && Category[0].DESCR != undefined && Category[0].DESCR != "" && Category[0].DESCR != " ") {
                    Tech_Token = Tech_Token + "&eqcat=" + Category[0].DESCR.toUpperCase()
                }
            }
            if (Trade != null && Trade != undefined && Trade != "" && Trade != " ") {
                Tech_Token = Tech_Token + "&eqtype=" + Trade
            }
            if (Assetdetails != null && Assetdetails != undefined && Assetdetails != "" && Assetdetails != " ") {
                if (Assetdetails[0].ISA_ASSET_MFG != null && Assetdetails[0].ISA_ASSET_MFG != undefined && Assetdetails[0].ISA_ASSET_MFG != "" && Assetdetails[0].ISA_ASSET_MFG != " ") {
                    Tech_Token = Tech_Token + "&eqmfg=" + Assetdetails[0].ISA_ASSET_MFG
                }
                if (Assetdetails[0].ISA_ASSET_MFG_ITM != null && Assetdetails[0].ISA_ASSET_MFG_ITM != undefined && Assetdetails[0].ISA_ASSET_MFG_ITM != "" && Assetdetails[0].ISA_ASSET_MFG_ITM != " ") {
                    Tech_Token = Tech_Token + "&eqmod=" + Assetdetails[0].ISA_ASSET_MFG_ITM
                }
            }
            if (AssetID != null && AssetID != undefined && AssetID != "" && AssetID != " ") {
                Tech_Token = Tech_Token + "&keyword=" + AssetID
            }

            //[01/30/2024, WW-942] open tech vault without search value - Nandhini L
            //else if (localStorage.getItem("WOAssetID") != "" && localStorage.getItem("WOAssetID") != undefined && localStorage.getItem("WOAssetID")!=null) {
            //   Tech_Token = Tech_Token + "&keyword=" + localStorage.getItem("WOAssetID")
            //}
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            //let encodeUrl = encodeURIComponent(Tech_Token);
            window.open(Tech_Token);
            // window.preventDefault()
            // return false;
        }

    }

    assignPageLoad = () => {
        const { t } = this.props
        let currentPagePath = this.props.location.pathname;
        if (currentPagePath == "/shoppingcart") {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
        let pageLoadData = JSON.parse(HomepageStore.pageLoadData);
        let Filecheck = pageLoadData.Filecheck;

        if (Filecheck && Filecheck[0].result) {
            let result = JSON.parse(Filecheck[0].result)
            let isRedirect = Filecheck[0].isRedirect
            const localStorageLanguageCode = CookieService.getLocalStorageValues("newlanguage");
            //const { result, isRedirect } = Filecheck;

            const langResult = result[0].messages;
            const displayDateTimeStart = ConvertToEst(result[0].displayDateTimeStart);
            const outageDateTimeStart = ConvertToEst(result[0].outageDateTimeStart);
            const outageDateTimeEnd = ConvertToEst(result[0].outageDateTimeEnd);

            const filteredLangResult = langResult.find(msg => msg.languageCode === localStorageLanguageCode.value);
            let externalMessage = filteredLangResult && filteredLangResult.externalMessage;
            externalMessage = externalMessage
                .replace('outageDateTimeStart', outageDateTimeStart)
                .replace('outageDateTimeEnd', outageDateTimeEnd);
            //externalMessage = externalMessage.replace("unavailable", "<span className='bolded-content'>unavailable</span>");
            CookieService.updateLocalStorageValues("displayText", externalMessage);
            CookieService.updateLocalStorageValues("isredirect", isRedirect);
            CookieService.updateLocalStorageValues("resultMessage", Filecheck);
            this.setState({
                displayText: externalMessage,
            })
            $('#OutageMsg').html(externalMessage.replace(/<br\s*\/?>/gi, ' '));
            if (isRedirect == "True") {

                let newlang = CookieService.getLocalStorageValues("newlanguage");
                let lastversion = CookieService.getLocalStorageValues("lastVersion");
                CookieService.setCookieValues(SDIConstants.access_token, "", -1);
                localStorage.clear();
                CookieService.updateLocalStorageValues("lastVersion", lastversion);
                let lv = CookieService.getLocalStorageValues("lastVersion");
                CookieService.updateLocalStorageValues("newlanguage", newlang);
                CookieService.updateLocalStorageValues("isSSOClick", false);
                CookieService.updateLocalStorageValues("isLogout", true);
                CookieService.updateLocalStorageValues("chgAndForPWClick", false);
                this.props.history.push({
                    pathname: `/`,
                });
            }

        }

        // 'WW-1196 - Home page optimization - Exception handling - Kishore
        let errorDt = pageLoadData.errorDt
        if (errorDt[0].errorFlag.toUpperCase() == "TRUE") {
            swal({
                allowOutsideClick: true,
                closeOnClickOutside: true,
                text: t('Technical issue please contact SDI help desk')
            });
            return;
        }


        //  $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let FrontEndFlags = pageLoadData.FrontEndFlags;
        let ExternalSiteList = pageLoadData.ExternalSiteList;


        console.log("refsitename", this.state.siteName)
        this.bindRefsiteDD(ExternalSiteList);
        /*********NEW******wal-158************/
        //let Part = pageLoadData.PartList;
        //let HallVendorsList = pageLoadData.HallVendorsTbl;
        //let HalCountryCode = pageLoadData.HalCountryCodeTbl;
        let pickuplist = pageLoadData.Pickup_VendorList;
        //WW-1229 Home tiles -Nandhini L
        let UserTiles = [];
        if (pageLoadData.UserMenu != null && pageLoadData.UserMenu != undefined && pageLoadData.UserMenu != []) {
            UserTiles = pageLoadData.UserMenu
        }
        //WW-1069 Only Catalog suppliers are shown in Sourced Non-Catalog Panel, need to show both catalog and non catalog supplier - Deepthi N H
        //let CatNonCatSuppList = pageLoadData.CatNonCatSuppliersList;
        //if (CatNonCatSuppList != undefined || CatNonCatSuppList != null) {
        //    localStorage.setItem("CatNoncatSupplierRec", JSON.stringify(CatNonCatSuppList));
        //}
        //CookieService.updateLocalStorageValues("SupplierData", Supplier);
        //WAL-541_PC_01 adding FavOrde category table in cookier(3/9/2022)-Aparna
        CookieService.updateLocalStorageValues("FavOrder_Category", pageLoadData.FavOrder_Category)
        //CPW-114_PC_07
        //let locSort = []
        //pageLoadData.SortingTable.forEach((x) => {
        //    locSort.push(x.SortedColumns)
        //})
        //CookieService.updateLocalStorageValues("Session_SortingTable", locSort)

        console.log("FavOrder_Category", CookieService.getLocalStorageValues("FavOrder_Category"));


        //[2/10/22, PC_HP_02, WW-330, Dhevanesm R]
        let StoreLocBen = pageLoadData.StoreLocBenDS

        //let make = [];
        //let model = [];
        //let assetdd = [];
        //let makeid = "0";
        //let modelid = "0";
        //let assetid = "0";
        ////if (Part.length > 0) {
        ////    make = Part.filter((v, i, a) => a.findIndex(t => (t.ISA_MAKE.trim().toUpperCase() === v.ISA_MAKE.trim().toUpperCase())) === i)
        ////}
        //const PartList = pageLoadData.PartList.reduce(
        //    (result, item) =>
        //        result.set(
        //            item.ISA_MAKE,
        //            (result.get(item.ISA_MAKE) || []).concat(item)
        //        ),
        //    new Map()
        //);
        //let arr = make.entries()
        //console.log("groups", PartList)
        //console.log("groups", PartList.get('HATCO'))
        //console.log("groups", PartList.entries().length)
        //console.log("groups size", PartList.size)
        //console.log("groups", PartList.entries())
        ////let ind=1
        ////console.log("groups", arr.next().value)
        ////console.log("groups", arr.value)
        ////console.log("groups", arr.next().value[ind])
        ////console.log("groups", arr.next().value[ind][1])
        //console.log("groups", arr.key)
        //console.log("groups", PartList.key)

        //console.log("groups", PartList.get())
        //[2/10/22, PC_HP_02, WW-330, Dhevanesm R]
        //ww-643- search pikup [3/13/2023]-PAVITHRA R 
        let strLocBenVal = []
        let pickUp = false
        let deliveryShipTo = false
        let delivery_optn = CookieService.getLocalStorageValues("Shipment_Method")
        let pick_up = localStorage.getItem("pickupcheck")
        if (delivery_optn != null || delivery_optn != undefined) {
            if (delivery_optn == true) {
                if (pick_up == null || pick_up == undefined || pick_up == "false") {
                    pickUp = false
                    deliveryShipTo = true
                }
                else {
                    pickUp = true
                    deliveryShipTo = false
                }
                this.setState({ pickUp: pickUp, deliveryShipTo: deliveryShipTo })


            }
        }


        if (StoreLocBen != null && StoreLocBen != "") {
            if (StoreLocBen.length > 0) {
                strLocBenVal = StoreLocBen
            }
        }
        CookieService.updateLocalStorageValues("Session_StoreLocBen", strLocBenVal);
        /*[05/04/22,Tile Not showing In PROD issue], Priyanka D */
        if (strLocBenVal[0] != undefined || strLocBenVal[0] != null) {
            CookieService.updateLocalStorageValues("Bentonville_Address", strLocBenVal[0].Bentonville_Address);
        }

        console.log("Bentonville_Address", CookieService.getLocalStorageValues("Bentonville_Address"))
        //if (PartList != null && PartList != undefined) {
        //    let loop = PartList.size
        //    if (PartList.size > 0) {
        //        for (const [index, value] of PartList.entries()) {
        //            let locmake = {
        //                ISA_MAKE: index,
        //                ISA_MAKE: index
        //            }
        //            make.push(locmake)

        //            PartList.get(index).map((val, index) => {
        //                if (index == 0) {
        //                    let defaultvalue = {
        //                        value: "0",
        //                        label: "--Select Asset ID--"
        //                    }
        //                    assetdd.push(defaultvalue)
        //                }
        //                let localArray = {
        //                    value: val.ISA_MACHINE_NO,
        //                    label: val.ISA_MACHINE_NO
        //                }

        //                assetdd.push(localArray)
        //            });

        //        }


        //    }
        //}
        //console.log("groups,assetdd", assetdd)
        //console.log("groups,make", make)
        //category.sort((a, b) => (a.DESCR > b.DESCR) ? 1 : -1)
        //Supplier = Supplier.sort((a, b) => (a.NAME1 > b.NAME1) ? 1 : -1)
        //let defaultasset = {
        //    value: "0",
        //    label: "--Select Asset ID--"
        //}
        //if (Part != null && Part != undefined) {
        //    if (Part.length > 0) {
        //        Part.map((val, index) => {
        //            if (index == 0) {
        //                let defaultvalue = {
        //                    value: "0",
        //                    label: "--Select Asset ID--"
        //                }
        //                assetdd.push(defaultvalue)
        //            }
        //            let localArray = {
        //                value: val.ISA_MACHINE_NO,
        //                label: val.ISA_MACHINE_NO
        //            }

        //            assetdd.push(localArray)
        //        });
        //    }
        //}


        //let assetback = assetdd
        /*****************END*******************/
        //FrontEndValues = this.state.FrontEndFlags
        //ExtendedSiteValues = this.state.ExternalSiteList
        //TradeCatalogValues = this.state.TradeCatalogList
        //if (localStorage.getItem("HalVendors") == null) {
        //    localStorage.setItem("HalVendors", JSON.stringify(HallVendorsList));
        //}
        //if (localStorage.getItem("HALCountryCode") == null) {
        //    localStorage.setItem("HALCountryCode", JSON.stringify(HalCountryCode));
        //}

        if (localStorage.getItem("PickupVendor") == null) {
            localStorage.setItem("PickupVendor", JSON.stringify(pickuplist));
        }
        //if (localStorage.getItem("PFCategory") == null) {
        //    localStorage.setItem("PFCategory", JSON.stringify(category));
        //}
        //if (localStorage.getItem("PFSupplier") == null) {
        //    localStorage.setItem("PFSupplier", JSON.stringify(Supplier));
        //}
        else {


        }
        if (localStorage.getItem("PFCatCount") == null) {
            localStorage.setItem("PFCatCount", 0);
        }
        else {
            if (JSON.parse(localStorage.getItem("PFCatCount")) > 0) {
                $("#supplierDIVid").addClass("disabledbutton");
                //this.setState({ catORsupp: "C" });
            }

            else {
                $("#supplierDIVid").removeClass("disabledbutton");
                // this.setState({ catORsupp: "" });
            }
        }

        if (localStorage.getItem("PFSuppCount") == null) {
            localStorage.setItem("PFSuppCount", 0);
        }
        else {
            if (JSON.parse(localStorage.getItem("PFSuppCount")) > 0) {
                $("#categoryDIVid").addClass("disabledbutton");
                //this.setState({ catORsupp: "C" });
            }
            else {
                $("#categoryDIVid").removeClass("disabledbutton");
                //this.setState({ catORsupp: "" });
            }
        }
        if (CookieService.getLocalStorageValues("PFMFGCount") == null || CookieService.getLocalStorageValues("PFMFGCount") == undefined) {
            CookieService.updateLocalStorageValues("PFMFGCount", 0);
            console.log("cookiestorageMFG", CookieService.getLocalStorageValues("PFMFGCount"))
        }
        //if (localStorage.getItem("PFMFGCount") == null) {
        //    localStorage.setItem("PFMFGCount", 0);
        //    console.log("localstorageMFG", localStorage.getItem("PFMFGCount"))
        //}
        //if (localStorage.getItem("Make") && localStorage.getItem("Make").trim()) {
        //    makeid = JSON.parse(localStorage.getItem("Make"));
        //}
        //if (localStorage.getItem("Model") && localStorage.getItem("Model").trim()) {
        //    modelid = JSON.parse(localStorage.getItem("Model"));
        //}
        //if (localStorage.getItem("AssetId") && localStorage.getItem("AssetId").trim()) {
        //    assetid = JSON.parse(localStorage.getItem("AssetId"));
        //}
        //this.setState({ CompletePartList: Part });
        //if (makeid != 0 && modelid != 0 && assetid != 0) {
        //    $(`#modelid`).prop('disabled', false)

        //    //let model = []
        //    let mm = [];
        //    let asset = [];

        //    //let assetdd = [];mm = this.state.PFPartlist.filter((x) => x.ISA_MAKE == make)
        //    mm = Part.filter((x) => x.ISA_MAKE == JSON.parse(localStorage.getItem("Make")))
        //    model = mm.filter((v, i, a) => a.findIndex(t => (t.ISA_MODEL.trim().toUpperCase() === v.ISA_MODEL.trim().toUpperCase())) === i)
        //    asset = mm.filter((x) => x.ISA_MAKE == JSON.parse(localStorage.getItem("Make")) && x.ISA_MODEL == JSON.parse(localStorage.getItem("Model")))
        //    // this.setState({ Model: makeid, Model: modelid, AssetID: assetid });
        //    assetid = asset[0].ISA_MACHINE_NO
        //    modelid = asset[0].ISA_MODEL
        //    Part = asset;
        //    defaultasset = {
        //        value: assetid,
        //        label: assetid
        //    }
        //    if (Part != null && Part != undefined) {
        //        assetdd = [];
        //        if (Part.length > 0) {
        //            Part.map((val, index) => {
        //                if (index == 0) {
        //                    let defaultvalue = {
        //                        value: "0",
        //                        label: "--Select Asset ID--"
        //                    }
        //                    assetdd.push(defaultvalue)
        //                }
        //                let localArray = {
        //                    value: val.ISA_MACHINE_NO,
        //                    label: val.ISA_MACHINE_NO
        //                }

        //                assetdd.push(localArray)
        //            });
        //        }
        //    }
        //}
        //WW-592 Tech Hub Link Updation 1/11/2023 - Pavithra R
        let techHub = ExternalSiteList.filter((x) => x.SITE_DESC.trim().toLowerCase() == "tech hub");
        let techHubURL = "";
        if (techHub.length > 0) {
            techHubURL = techHub[0].SITE_URL;
        }
        this.setState({ techHubURL: techHubURL })



        // assetdd = assetdd.filter((v, i, a) => a.findIndex(t => (t.value.trim().toUpperCase() === v.value.trim().toUpperCase())) === i && v.value.trim().toUpperCase()!= "NONE") 

        //let Favmenu = pageLoadData.FavMenu;
        //let Favsub = PageLaod_Data.FavSubMenu;
        //let TradeTree = PageLaod_Data.TradeCatalogList;
        //let TradeValue = []
        //let Searchdata = PageLaod_Data.SearchItemTable;
        //let AttributeValue = []
        //CookieService.updateLocalStorageValues("PFMake", make);
        //CookieService.updateLocalStorageValues("PFModel", model);
        //CookieService.updateLocalStorageValues("PFAsset", assetdd);
        this.setState({
            ExternalSiteList: pageLoadData.ExternalSiteList[0],
            //TradeCatalogList: pageLoadData.TradeCatalogList[0],
            PFCategory: localStorage.getItem("PFCategory") == null ? [] : JSON.parse(localStorage.getItem("PFCategory")),
            PFSupplier: localStorage.getItem("PFSupplier") == null ? [] : JSON.parse(localStorage.getItem("PFSupplier")),
            //PFPartlist: Part,
            //MakeList: make,
            //AssetList: assetdd,
            //DefaultAsset: defaultasset,
            //Make: makeid,
            //ModelList: model,
            //Model: modelid,
            //AssetID: defaultasset,
            //AssetBack: assetback,

            UserTiles: UserTiles //WW-1229 Home tiles -Nandhini L


        });
        localStorage.setItem('isNoncatClick', "false");
        localStorage.setItem('isInteractiveClick', "false");
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }

    onChange(e) {
        let test = $('#Delivery_Method').hasClass('show')
        if (!test) {
            this.setState({
                autoCompleteValue: e.target.value
            });
            if (e.target.value.length > 0) {
                this.retrieveDataAsynchronously(e.target.value);
            }
        }
        //else {
        //    this.setState({
        //        autoCompleteValue: ""
        //    });
        //}




        /**
         * Handle the remote request with the current text !
         */


    }
    //WW-1229 Home tiles -Nandhini L
    BindHomeTiles = () => {
        let UserTiles = this.state.UserTiles.filter(tile => tile.SITE_NAME.includes('W'));

        if (UserTiles.length > 0) {
            return (
                <div className="container-fluid profile-update">
                    <div className="row my-5">
                        {UserTiles.map((value, index) => (
                            value.SECURITYALIAS == "HT-APPRVQUOT" ? (
                                <a key={index} className="custom-category-section relative-a" onClick={e => this.onClickHomeTiles(e, value.SECURITYALIAS, value.ISA_NAVIGATIONURL)}>
                                    <img
                                        className="custom-category-img"
                                        style={value.SECURITYALIAS === "HT-SRCNCE" ? { width: '25%' } : {}}
                                        src={value.TILE_IMAGE}
                                        alt={value.ISA_IDENTIFIER_NAME}
                                    />
                                    <span id="request-loader" className="cart-count approval request-count ">
                                        <RotatingLines
                                            strokeColor="#FFFFFF"
                                            strokeWidth="5"
                                            animationDuration="0.75"
                                            width="18"
                                            visible={true} />
                                    </span>
                                    <span id="request-count" className={`cart-count approval request-count 
                                            ${localStorage.getItem("requestorApprovalCount") != undefined && localStorage.getItem("requestorApprovalCount") != null && localStorage.getItem("requestorApprovalCount") != "" ?
                                            localStorage.getItem("requestorApprovalCount").toString().split('').length == 1 ? 'null-count' :
                                                localStorage.getItem("requestorApprovalCount").toString().split('').length == 3 ? 'threedigit-count' : '' : ''}`}>{localStorage.getItem("requestorApprovalCount")}</span>
                                    <p className="custom-category-title">
                                        <Trans>{value.ISA_IDENTIFIER_NAME}</Trans>
                                    </p>
                                </a>
                            ) :
                                value.SECURITYALIAS !== "HT-TECHHUB" ? (
                                    <a key={index} className="custom-category-section" onClick={e => this.onClickHomeTiles(e, value.SECURITYALIAS, value.ISA_NAVIGATIONURL)}>
                                        <img
                                            className="custom-category-img"
                                            style={value.SECURITYALIAS === "HT-SRCNCE" ? { width: '25%' } : {}}
                                            src={value.TILE_IMAGE}
                                            alt={value.ISA_IDENTIFIER_NAME}
                                        />
                                        <p className="custom-category-title">
                                            <Trans>{value.ISA_IDENTIFIER_NAME}</Trans>
                                        </p>
                                    </a>
                                ) :
                                    (
                                        <a key={index} href={this.state.techHubURL} target="_blank" rel="noopener noreferrer" className="custom-category-section">
                                            <img
                                                className="custom-category-img"
                                                style={value.SECURITYALIAS === "HT-SRCNCE" ? { width: '25%' } : {}}
                                                src={value.TILE_IMAGE}
                                                alt={value.ISA_IDENTIFIER_NAME}
                                            />
                                            <p className="custom-category-title">
                                                <Trans>{value.ISA_IDENTIFIER_NAME}</Trans>
                                            </p>
                                        </a>
                                    )
                        ))}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
    //WW-1229 Home tiles -Nandhini L
    onClickHomeTiles = (e, tileName, navURL) => {
        e.preventDefault();
        let WO;
        switch (tileName) {
            case 'HT-EQPPARTS':
                const WO_EQPPARTS = localStorage.getItem("WONum");
                localStorage.setItem("isEquipmentClick", "true");

                if (WO_EQPPARTS) {
                    this.headerRedirect(e, navURL);
                } else {
                    $('#WorkOrderPopUpHome').modal('show');
                }
                break;
            case 'HT-HELP':
                let customFields = []
                let PassAutheBO = {
                    UserID: CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    UserBu: CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    EmailID: CookieService.getLocalStorageValues("Session_EMAIL"),
                    IsThirdParty: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false,
                    PassWord: "",
                    OrderNumber: "",
                    PONumber: "",
                    HomepageRequest: true,
                    customFields: customFields
                }
                HomepageAction.getPassThroughAutheURl(PassAutheBO)
                break;
            case 'HT-NONCAT':
                WO = localStorage.getItem("WONum")
                localStorage.setItem('isNoncatClick', "true");

                if (WO != undefined && WO != null && WO.trim() != "") {
                    this.noncat(e);
                }
                else {
                    $('#WorkOrderPopUpHome').modal('show');
                }
                break;
            case 'HT-TECHVAULT':
                WO = localStorage.getItem("WONum")
                if (WO != undefined && WO != null && WO.trim() != "") {
                    this.TechVault();
                }
                else {
                    $('#WorkOrderPopUpHome').modal('show');
                }
                break;
            case 'HT-INTDIAD':
                WO = localStorage.getItem("WONum")
                localStorage.setItem('isInteractiveClick', "true");

                if (WO != undefined && WO != null && WO.trim() != "") {
                    this.headerRedirect(e, "/interactivediagram/")
                }
                else {
                    $('#WorkOrderPopUpHome').modal('show');
                }
                break;
            default:
                this.headerRedirect(e, navURL)
                break;
        }
    }
    /**
  * Callback triggered when the autocomplete input changes.
  * 
  * @param {Object} val Value returned by the getItemValue function.
  * @return {Nothing} No value is returned
  */
    partlistresult = () => {

    }
    // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
    onSelect(event) {
        this.setState({
            autoCompleteValue: event, productData: [], suggestionData: []
        }, () => {
            this.inputRef.current.focus(); // WW - 5610 - Focus after selecting a suggestion [4/10/2025] - Nachiappan
        });

    }

    /** Define which property of the autocomplete source will be show to the user.
   * 
   * @param { Object } item Single object from the data that can be shown inside the autocomplete
    * @return { String } val
        */
    getItemValue(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.value}`;
    }

    /**
 * Reusable method for click of header link navigation
 */
    headerRedirect = (event, pageName) => {
        if (pageName == "/interactivediagram/") {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
        let queryParamindex = pageName.indexOf("?");
        let pagePath = pageName;
        let queryParams = "";
        if (queryParamindex > 0) {
            pagePath = pageName.substring(0, queryParamindex);
            queryParams = pageName.substring(queryParamindex, pageName.length);
        };

        this.props.history.push({
            pathname: pagePath,
            search: queryParams
        });
        if (event) {
            event.preventDefault();
        }

    };

    searchKeyPress = (event) => {
        if (event.keyCode == 13) {
            this.setState({
                autocompleteData: [],
            });
            //searchid.current.blur();
            // $('#searchid').blur();
            //  $("#searchid").autocomplete("disable");
            document.activeElement.blur();
            //$("#searchid").attr("disabled", true);

            this.searchClick("Global");
        };
    };
    // WAL-1145  Suppler suggestion sorting [8/28/2023] Pavithra R
    //ww-643- search pikup [3/13/2023]-PAVITHRA R
    searchClick = (searchType) => {
        const { t } = this.props
        //WW-1378_WW-1382- Update search properties to new state - Nandhini L
        CookieService.updateLocalStorageValues('fromSearch', false);
        CookieService.updateLocalStorageValues('pageNo', "");
        CookieService.updateLocalStorageValues('GridType', "");
        CookieService.updateLocalStorageValues('pageCount', "");
        CookieService.updateLocalStorageValues("ImageSearch", "");
        CookieService.updateLocalStorageValues("FilePath", "");
        CookieService.updateLocalStorageValues("FileName", "");
        CookieService.updateLocalStorageValues("SearchUrl", "");

        let Shipment_Method = CookieService.getLocalStorageValues("Shipment_Method")

        //WW-1374 problem code search - Nandhini L 
        if (searchType == "IsProblemCodeSearch") {
            this.props.history.push({
                pathname: `\searchresults`,
                state: { ImageSearch: false, ImageFiles: "", image: "" }
            });
            return
        }

        //WW-1374 Update problem code search as false for other search - Nandhini L 
        CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);

        if (searchType == "PartsList") {
            this.setState({
                IsPartList: true
            });
        }
        if (IsImageSearch) {
            if (this.state.pickUp == true || this.state.deliveryShipTo == true) {
                $('#Delivery_Method').modal('hide');
                IsImageSearch = false
                this.fileInputRef.current.click();
                return
            }
            else {
                this.setState({ shipmentmethoderrorid: "Please select the Shipment Method" })
            }
        }
        else if (this.state.autoCompleteValue.trim() && !this.state.IsPartList) {
            if (Shipment_Method == false) {
                this.setState({
                    productData: [], suggestionData: [],
                });
                console.log("autocomplete", this.state.autocompleteData)
                $('#Delivery_Method').modal('show');
                CookieService.updateLocalStorageValues("Shipment_Method", true)
            }

            else {
                if (this.state.pickUp == true || this.state.deliveryShipTo == true) {

                    $('#Delivery_Method').modal('hide');
                    localStorage.setItem("pageNo", 1)
                    CookieService.updateLocalStorageValues("searchKey", this.state.autoCompleteValue.trim());
                    let autocomplete = this.state.autoCompleteValue.replace(/&/g, "%26") //WW-875_PC_01
                    autocomplete = autocomplete.replace(/#/g, "%23")
                    this.props.history.push({
                        pathname: `\searchresults`,
                        search: `?key=${autocomplete.trim()}&Make=&Model=&AssetId=&`,
                        state: { ImageSearch: false, ImageFiles: "", image: "" }
                    });



                }


                else {
                    this.setState({ shipmentmethoderrorid: "Please select the Shipment Method" })
                }

            }
        }

        else if (this.state.IsPartList) {
            if (this.state.Make != "0" && this.state.Model != "0" && this.state.AssetID.value != "0") {
                if (Shipment_Method == false) {
                    $('#Delivery_Method').modal('show');
                    CookieService.updateLocalStorageValues("Shipment_Method", true)
                }
                else {
                    localStorage.setItem("Make", JSON.stringify(this.state.Make));
                    localStorage.setItem("Model", JSON.stringify(this.state.Model));
                    localStorage.setItem("AssetId", JSON.stringify(this.state.AssetID.value));
                    CookieService.updateLocalStorageValues("searchKey", "");

                    if (this.state.pickUp == true || this.state.deliveryShipTo == true) {

                        $('#Delivery_Method').modal('hide');
                        localStorage.setItem("pageNo", 1)
                        CookieService.updateLocalStorageValues("searchKey", this.state.autoCompleteValue.trim());
                        let Make = this.state.Make
                        Make = Make.replace(/&/g, "%26")
                        Make = Make.replace(/#/g, "%23")
                        let Model = this.state.Model
                        Model = Model.replace(/&/g, "%26")
                        Model = Model.replace(/#/g, "%23")
                        this.props.history.push({
                            pathname: `\searchresults`,
                            search: `?key=&Make=${Make.trim()}&Model=${Model.trim()}&AssetId=${this.state.AssetID.value}`,
                            state: { ImageSearch: false, ImageFiles: "", image: "" }
                        });



                    }
                    else {
                        this.setState({ shipmentmethoderrorid: "Please select the Shipment Method" })
                    }

                }
            }
            else {
                $('#PartsListErr').removeClass('d-none');
            }



        }
    }
    //ww-643- search pikup [3/13/2023]-PAVITHRA R
    shpCloseClk = () => {
        $('#Delivery_Method').modal('hide');
        IsImageSearch = false
        this.setState({ shipmentmethoderrorid: "" })
        CookieService.updateLocalStorageValues("Shipment_Method", false);
        localStorage.setItem("pickupcheck", false);
        this.setState({ pickUp: false, deliveryShipTo: true });
    }



    renderItem(item, isHighlighted) {
        return (
            <div key={item.label} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>
        );

    }

    fetchPrefilterData = (Type, SearchText) => {
        let localType = [];
        if (Type == "Supplier") {
            localType = localStorage.getItem("PFSupplier");
        } else if (Type == "TradeCatalog") {
            localType = localStorage.getItem("PFCategory");
        }
        if (!localType) {
            const userID = this.state.Login_UserId;
            const BU = this.state.Login_UserBU;

            let prefilterDataBO = {
                userID,
                BU,
                Type,
                SearchText
            };

            this.setState({
                Type: Type
            }, () => {
                HomepageAction.getPreFilterData(prefilterDataBO);  // Assuming redux action
            });
        } else {
            if (Type == "Supplier") {
                this.setState({ PFSupplier: localStorage.getItem("PFSupplier") == null ? [] : JSON.parse(localStorage.getItem("PFSupplier")) })
            } else if (Type == "TradeCatalog") {
                this.setState({ PFCategory: localStorage.getItem("PFCategory") == null ? [] : JSON.parse(localStorage.getItem("PFCategory")) })
            }
        }
    }
    fetchPrefilterDataResponse = () => {
        const { t } = this.props
        let response = JSON.parse(HomepageStore.preFilter);  // assuming correct store binding

        if (response === "Technical issue") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Technical Issue. Please contact SDI Customer Care")
            });
            return;
        }

        if (this.state.Type === "Supplier") {
            localStorage.setItem("PFSupplier", JSON.stringify(response.Table));
            supplierPresent = true;
            this.setState({ PFSupplier: response.Table, viewsup: false, selectallSup: true });
        } else if (this.state.Type == "TradeCatalog") {
            localStorage.setItem("PFCategory", JSON.stringify(response.Table));
            CategoryPresent = true;
            this.setState({ PFCategory: response.Table, viewcat: false, selectallCat: true });
        }


    }
    retrieveDataAsynchronously = async (searchText) => {
        let searchBO = {
            keywordStartsWith: searchText,
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
            Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
            Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
            Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
            Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
            Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
            Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
            Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
            Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
            Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
            Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            Session_ZEUSNOCATALOGSITE: CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE"),
            Session_ZEUS_SITE: CookieService.getLocalStorageValues("Session_ZEUS_SITE"),
            SearchType: CookieService.getLocalStorageValues("SearchType") === "Sup P.#" ? "supplier part #" : CookieService.getLocalStorageValues("SearchType") === "MFG P.#" ? "manufacturer part #" : "all",
        }
        let responseData = await MenuAction.getSearchSuggestions(searchBO);
        let autoCompleteDataRes = [];
        let suggestionsStr = []
        if (responseData != "") {
            responseData = JSON.parse(responseData);
            // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
            const productArray = [];
            const suggestionArray = [];

            responseData.forEach(item => {
                if (item.Header === 'ProductSuggestions') {
                    productArray.push({ label: item.SuggestionsValue, value: item.SuggestionsValue });
                } else if (item.Header === 'Suggestions') {
                    suggestionArray.push({ label: item.SuggestionsValue, value: item.SuggestionsValue });
                }
            });

            //suggestionsStr = responseData.filter((item) => item != null);

            //suggestionsStr.forEach((sugg, index) => {
            //    autoCompleteDataRes.push({ label: sugg, value: sugg });
            //});
            //let test = $('#Shipment_Method').hasClass('show')
            //if (!test) {
            this.setState({ productData: productArray, suggestionData: suggestionArray });
            //}
        }
    }
    //handleBlur = (e) => {
    //    if (e.relatedTarget) {
    //        e.stopPropagation();
    //        this.setState({ productData: [], suggestionData: [ ]});
    //    }
    //};

    // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 

    displaySuggestions = () => {
        const wrapClass = (length) => length <= 3 ? 'wrapped-dropdown' : '';
        if (this.state.productData && this.state.suggestionData && this.state.productData.length > 0 && this.state.suggestionData.length > 0) {
            //if (this.state.productData.length > 0 && this.state.suggestionData.length > 0) {
            // Display both product suggestions and general suggestions
            return (
                //<div className="container-fluid mt-4">
                <div className="search-suggestion-menu-container">
                    <div className="search-suggestion-title-container w-100">
                        <h3 className="search-suggestion-title m-0"><Trans>Previously Purchased Items</Trans></h3>
                    </div>
                    <ul className="search-suggestion-menu-items Purchase-suggestion-menu-items mb-2">
                        {this.state.productData.map((product, index) => (
                            <li key={`product-${index}`} onClick={(e) => this.onSelect(product.value)} ><button className="btn">{product.value}</button></li>
                        ))}
                    </ul>

                    <div className="search-suggestion-divider-section">
                    </div>
                    <div className="search-suggestion-title-container w-100">
                        <h3 className="search-suggestion-title m-0"><Trans>Suggestions</Trans></h3>
                    </div>

                    <ul className="search-suggestion-menu-items Purchase-suggestion-menu-items mb-2">
                        {this.state.suggestionData.map((suggestion, index) => (
                            <li key={`suggestion-${index}`} onClick={(e) => this.onSelect(suggestion.value)} ><button className="btn">{suggestion.value}</button></li>
                        ))}
                    </ul>
                </div>
                //</div>

            );
            //}
        } else if (this.state.suggestionData && this.state.suggestionData.length > 0) {
            //if (this.state.suggestionData.length > 0) { 

            // Display only general suggestions
            return (
                //<div className="container-fluid mt-4">
                <div className="search-suggestion-menu-container">
                    <div className="search-suggestion-title-container w-100">
                        <h3 className="search-suggestion-title m-0"><Trans>Suggestions</Trans></h3>
                    </div>
                    <ul className="search-suggestion-menu-items Purchase-suggestion-menu-items mb-2">
                        {this.state.suggestionData.map((suggestion, index) => (
                            <li key={`suggestion-${index}`} onClick={(e) => this.onSelect(suggestion.value)}><button className="btn">{suggestion.value}</button></li>
                        ))}
                    </ul>
                </div>
                //</div>

            );
            //}
        } else if (this.state.productData && this.state.productData.length > 0) {
            //if (this.state.productData.length > 0) {

            // Display only product suggestions
            return (
                //<div className="container-fluid mt-4">
                <div className="search-suggestion-menu-container">
                    <div className="search-suggestion-title-container w-100">
                        <h3 className="search-suggestion-title m-0"><Trans>Previously Purchased Items</Trans></h3>
                    </div>
                    <ul className="search-suggestion-menu-items Purchase-suggestion-menu-items mb-2">
                        {this.state.productData.map((product, index) => (
                            <li key={`product-${index}`} onClick={(e) => this.onSelect(product.value)}><button className="btn">{product.value}</button></li>
                        ))}
                    </ul>
                </div>
                //</div>

            );


        } else {
            // No suggestions available
            return <div></div>;
        }
    }
    // WW-1336 - Relevant Type Ahead Suggestions - [3/14/2025] - K Surya 
    clearSearch = () => {
        this.setState({ autoCompleteValue: "", suggestionData: [], productData: [] });
    }
    referenceSiteChange = (e) => {

        this.setState({ referenceSite: e.value, siteName: e.label });
    }
    referenceSiteNavigation = (e, site) => {
        const { t } = this.props
        e.preventDefault();
        swal({
            allowOutsideClick: false,
            closeOnClickOutside: false,
            text: t(`Links are for reference information only.\nDo not place orders from suppliers site.`)
        }).then(function () {
            //console.log("referenceSite", site)
            //if (this.state.referenceSite)
            //    /***NEW******wal-158***/
            window.open(site);
        });
        //  alert(`Links are for reference information only.\nDo not place orders from suppliers site.`);

        //window.location.href = this.state.referenceSite;
        /**********END************/
    }

    /* Method to select all and unselect all category, Supplier prefilters*/
    selectall = (selectval) => {

        if (selectval == 'CAT') {
            let PFCat = JSON.parse(localStorage.getItem("PFCategory"))
            let catcount = JSON.parse(localStorage.getItem("PFCatCount"))
            let search = $(`#categoryid`).val()
            //WW-633_PC_05 (2/24/2023-Aparna)
            if (search != "" && search != " " && search != undefined) {
                if (PFCat != null) {
                    if (this.state.selectallCat == true) {

                        PFCat.map((val, index) => {
                            if (val.DESCR.toUpperCase().includes(search.toUpperCase())) {
                                if (PFCat[index].checked != true) {
                                    catcount += 1;
                                }
                                PFCat[index].checked = true;
                            }
                        })
                        localStorage.setItem("PFCategory", JSON.stringify(PFCat));
                        localStorage.setItem("PFCatCount", JSON.stringify(catcount));
                        this.setState({ selectallCat: false, PFCategory: PFCat })
                    } else {

                        PFCat.map((val, index) => {
                            if (val.DESCR.toUpperCase().includes(search.toUpperCase())) {
                                PFCat[index].checked = false;
                                catcount -= 1;
                            }
                        })
                        localStorage.setItem("PFCategory", JSON.stringify(PFCat));
                        localStorage.setItem("PFCatCount", JSON.stringify(catcount));
                        this.setState({ selectallCat: true, PFCategory: PFCat, viewcat: false })

                    }
                }
            }
            else {
                if (PFCat != null) {
                    if (this.state.selectallCat == true) {

                        PFCat.map((val, index) => {
                            if (PFCat[index].checked != true) {
                                catcount += 1;
                            }
                            PFCat[index].checked = true;
                        })
                        localStorage.setItem("PFCategory", JSON.stringify(PFCat));
                        localStorage.setItem("PFCatCount", JSON.stringify(catcount));
                        this.setState({ selectallCat: false, PFCategory: PFCat })
                    } else {

                        PFCat.map((val, index) => {
                            PFCat[index].checked = false;
                        })
                        localStorage.setItem("PFCategory", JSON.stringify(PFCat));
                        localStorage.setItem("PFCatCount", JSON.stringify(0));
                        this.setState({ selectallCat: true, PFCategory: PFCat, viewcat: false })

                    }
                }
            }

        }
        if (selectval == 'SUP') {
            let PFSup = JSON.parse(localStorage.getItem("PFSupplier"));
            let PFcount = JSON.parse(localStorage.getItem("PFSuppCount"));
            //WW-633_PC_05 (2/24/2023-Aparna)
            let search = $(`#supplierid`).val()
            if (search != "" && search != " " && search != undefined) {
                if (PFSup != null) {
                    if (this.state.selectallSup == true) {
                        PFSup.map((val, index) => {
                            if (val.NAME1.toUpperCase().includes(search.toUpperCase())) {
                                if (PFSup[index].checked != true) {
                                    PFcount += 1;
                                }
                                PFSup[index].checked = true;
                            }
                        })
                        localStorage.setItem("PFSupplier", JSON.stringify(PFSup));
                        localStorage.setItem("PFSuppCount", JSON.stringify(PFcount));
                        this.setState({ selectallSup: false, PFSupplier: PFSup })
                    } else {
                        PFSup.map((val, index) => {
                            if (val.NAME1.toUpperCase().includes(search.toUpperCase())) {
                                PFSup[index].checked = false;
                                PFcount -= 1;
                            }
                        })
                        localStorage.setItem("PFSupplier", JSON.stringify(PFSup));
                        localStorage.setItem("PFSuppCount", JSON.stringify(PFcount));
                        this.setState({ selectallSup: true, PFSupplier: PFSup, viewsup: false })
                    }
                }
            }
            else {
                if (PFSup != null) {
                    if (this.state.selectallSup == true) {
                        PFSup.map((val, index) => {
                            if (PFSup[index].checked != true) {
                                PFcount += 1;
                            }
                            PFSup[index].checked = true;
                        })
                        localStorage.setItem("PFSupplier", JSON.stringify(PFSup));
                        localStorage.setItem("PFSuppCount", JSON.stringify(PFcount));
                        this.setState({ selectallSup: false, PFSupplier: PFSup })
                    } else {
                        PFSup.map((val, index) => {
                            PFSup[index].checked = false;
                        })
                        localStorage.setItem("PFSupplier", JSON.stringify(PFSup));
                        localStorage.setItem("PFSuppCount", JSON.stringify(0));
                        this.setState({ selectallSup: true, PFSupplier: PFSup, viewsup: false })
                    }
                }
            }
        }
        //WW-633_PC_03 (2/24/2023)-Aparna
        if (selectval == 'MFG') {
            let PFMfg = this.state.PFManufacturer
            let PFcount = JSON.parse(localStorage.getItem("PFMFGCount"));

            if (PFMfg != null) {
                if (this.state.selectallMfg == true) {
                    PFMfg.map((val, index) => {
                        if (PFMfg[index].checked != true) {
                            PFcount += 1;
                        }
                        PFMfg[index].checked = true;
                    })
                    let loc = [];
                    let selectedMFG = PFMfg.filter((x) => x.checked == true);
                    selectedMFG.forEach((val) => {
                        loc.push({
                            BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                            MFG_ID: val.MFG_ID
                        })
                    })
                    loc = loc.filter((v, i, a) => a.findIndex(t => (t.MFG_ID.trim().toUpperCase() === v.MFG_ID.trim().toUpperCase())) === i)
                    localStorage.setItem("PFMFG", JSON.stringify(PFMfg));
                    localStorage.setItem("PFMFGCount", JSON.stringify(PFcount));
                    this.setState({ selectallMfg: false, PFManufacturer: PFMfg, MFGchecked: loc })
                } else {
                    PFMfg.map((val, index) => {
                        PFMfg[index].checked = false;
                    })

                    localStorage.setItem("PFMFG", JSON.stringify(PFMfg));
                    localStorage.setItem("PFMFGCount", JSON.stringify(0));
                    this.setState({ selectallMfg: true, PFManufacturer: PFMfg, viewmfg: false })
                }
            }
        }
    }
    SelectAllMfg = () => {

        let PFMfg = this.state.MFGArray;
        let PFcount = this.state.MFGSelectedCount;
        if (this.state.selectallMfg == true) {
            PFMfg.map((val, index) => {
                if (PFMfg[index].checked != true) {
                    PFcount += 1;
                }
                PFMfg[index].checked = true;
            })
            let loc = this.state.ViewMfgList;
            let selectedMFG = PFMfg.filter((x) => x.checked == true);
            selectedMFG.forEach((val) => {
                loc.push({
                    BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                    MFG_ID: val.MFG_ID.toUpperCase()
                })
            })
            loc = loc.filter((v, i, a) => a.findIndex(t => (t.MFG_ID.trim().toUpperCase() === v.MFG_ID.trim().toUpperCase())) === i)
            this.setState({ selectallMfg: false, MFGArray: PFMfg, ViewMfgList: loc, MFGSelectedCount: PFcount })
        }
        else {
            let loc = this.state.ViewMfgList;
            PFMfg.map((val, index) => {
                PFMfg[index].checked = false;
                loc = loc.filter((x) => x.MFG_ID.trim().toUpperCase() != val.MFG_ID.trim().toUpperCase());
            })
            let selectedCount = loc.length;
            let view = selectedCount.length > 0 ? true : false;
            this.setState({ selectallMfg: true, MFGArray: PFMfg, viewmfg: view, ViewMfgList: loc, MFGSelectedCount: selectedCount })
        }
    }
    /* Viewcat method to view selected category*/
    viewcat = () => {
        ;
        if (this.state.viewcat == true) {
            this.setState({ viewcat: false });
        } else {
            this.setState({ viewcat: true });
        }
    }
    /* Viewcat method to view selected supplier*/
    viewselectionSup = () => {
        ;
        if (this.state.viewsup == true) {
            this.setState({ viewsup: false });
        } else {
            this.setState({ viewsup: true });
        }
    }
    /* Viewcat method to view selected mfg*/
    viewselectedmfg = () => {
        //WW-633_PC_04 (2/24/2023)-Aparna
        if (this.state.viewmfg == false) {
            this.setState({ viewmfg: true });
        } else {
            this.setState({ viewmfg: false });
        }
        //this.ManufacturerBind();

    }

    /*****NEW********wal-158*** **************************************************************************************************************/
    CategoryBind = (searchval) => {
        let PFCat = localStorage.getItem("PFCategory")
        if (PFCat != null) {
            PFCat = JSON.parse(localStorage.getItem("PFCategory"));
        }
        if (PFCat != null) {
            let search = $(`#categoryid`).val()
            //WW-633_PC_05 (2/24/2023-Aparna)
            if (search != "" && search != " " && search != undefined) {
                CategoryPresent = false;
            }
            if (this.state.viewcat == false) {
                return PFCat.map((val, index) => {
                    //if (search != "" && search != undefined && val.DESCR.toUpperCase().indexOf(search.toUpperCase())===-1) {
                    //    return null
                    //}
                    let t = val.checked == false || val.checked == undefined ? false : true;
                    if (search != "" && search != " " && search != undefined) {
                        if (val.DESCR.toUpperCase().includes(search.toUpperCase())) {
                            CategoryPresent = true;
                            return (
                                <div className="custom-control custom-checkbox my-2 item-custom-control custcheck w-100" key={`pfcat${index}`}>
                                    <input type="checkbox" className="custom-control-input" id={`cat${index + 1}`} name="example1" checked={t} onChange={(event) => this.selectOrder(event, index, "category", val)} />
                                    <label className="custom-control-label priority-checkbox filter-checkbox" style={{ textTransform: "uppercase" }} htmlFor={`cat${index + 1}`} >{val.DESCR}</label>
                                </div>)
                        }
                    }
                    else {
                        CategoryPresent = true;
                        return (
                            <div className="custom-control custom-checkbox my-2  item-custom-control custcheck w-100" key={`pfcat${index}`}>
                                <input type="checkbox" className="custom-control-input" id={`cat${index + 1}`} name="example1" checked={t} onChange={(event) => this.selectOrder(event, index, "category", val)} />
                                <label className="custom-control-label priority-checkbox filter-checkbox" style={{ textTransform: "uppercase" }} htmlFor={`cat${index + 1}`} > {val.DESCR} </label>
                            </div>)
                    }


                });
            }
            //To display the selected category boxes alone
            else {
                return PFCat.map((val, index) => {

                    let t = val.checked == false || val.checked == undefined || val.checked == null ? false : true;
                    if (t == true) {
                        CategoryPresent = true;
                        return (
                            <div className="custom-control custom-checkbox my-2   item-custom-control  custcheck">
                                <input type="checkbox" className="custom-control-input" id={`cat${index + 1}`} name="example1" checked={t} onChange={(event) => this.selectOrder(event, index, "category", val)} />
                                <label className="custom-control-label priority-checkbox filter-checkbox" style={{ textTransform: "uppercase" }} htmlFor={`cat${index + 1}`} >{val.DESCR}</label>
                            </div>)
                    }
                });
                this.setState({ viewcat: false });
            }
        }
    }
    categorysearch = () => {
        this.CategoryBind($(`#categoryid`).val());
        this.setState({ catsearch: $(`#categoryid`).val(), selectallCat: true });
    }
    selectOrder = (e, index, filter, v) => {
        if (filter == "category") {
            let PFCat = this.state.PFCategory;
            let selectCat = [];
            let selectAll = this.state.selectallCat;
            let Catlist = [];
            let catIndex;
            if (this.state.catsearch == "") {
                Catlist = PFCat;
            }
            else {
                Catlist = PFCat.filter((x) => x.DESCR.toUpperCase().includes(this.state.catsearch.toUpperCase()));
            }
            catIndex = Catlist.findIndex(t => (t.DESCR.trim().toUpperCase() === PFCat[index].DESCR.trim().toUpperCase()))
            if ($(`#cat${index + 1}`).prop('checked') == true) {
                PFCat[index].checked = true;
                Catlist[catIndex].checked = true;
                selectCat = Catlist.filter((x) => x.checked == true);
                if (selectCat.length == Catlist.length) {
                    selectAll = false
                }
                catcount = JSON.parse(localStorage.getItem("PFCatCount")) + 1;
                localStorage.setItem("PFCatCount", JSON.stringify(catcount));
                localStorage.setItem("PFCategory", JSON.stringify(PFCat));
            }
            else {
                PFCat[index].checked = false;
                Catlist[catIndex].checked = false;
                selectCat = Catlist.filter((x) => x.checked == false);
                if (selectCat.length == Catlist.length) {
                    selectAll = true
                }
                catcount = JSON.parse(localStorage.getItem("PFCatCount")) - 1;
                localStorage.setItem("PFCatCount", JSON.stringify(catcount));
                localStorage.setItem("PFCategory", JSON.stringify(PFCat));
                if (catcount == 0) {
                    this.CatClearClick("CAT");
                }

            }

            if (catcount > 0) {
                $("#supplierDIVid").addClass("disabledbutton");
                this.setState({ catORsupp: "C", selectallCat: selectAll });
            }
            else {
                $("#supplierDIVid").removeClass("disabledbutton");
                this.setState({ catORsupp: "", selectallCat: selectAll });
            }
        }
        else if (filter == "supplier") {
            let PFSuppl = this.state.PFSupplier;
            let selectSupp = []
            let selectAll = this.state.selectallSup;
            let SupList = [];
            let SupIndex;
            if (this.state.supsearch == "") {
                SupList = PFSuppl;
            }
            else {
                SupList = PFSuppl.filter((x) => x.NAME1.toUpperCase().includes(this.state.supsearch.toUpperCase()));
            }
            SupIndex = SupList.findIndex(t => (t.NAME1.trim().toUpperCase() === PFSuppl[index].NAME1.trim().toUpperCase()))
            if ($(`#supp${index + 1}`).prop('checked') == true) {
                PFSuppl[index].checked = true;
                SupList[SupIndex].checked = true;
                selectSupp = SupList.filter((x) => x.checked == true);
                if (selectSupp.length == SupList.length) {
                    selectAll = false
                }
                suppcount = JSON.parse(localStorage.getItem("PFSuppCount")) + 1;
                localStorage.setItem("PFSuppCount", JSON.stringify(suppcount));
                localStorage.setItem("PFSupplier", JSON.stringify(PFSuppl));
            }
            else {
                PFSuppl[index].checked = false;
                SupList[SupIndex].checked = false;
                selectSupp = SupList.filter((x) => x.checked == false);
                if (selectSupp.length == SupList.length) {
                    selectAll = true
                }
                suppcount = JSON.parse(localStorage.getItem("PFSuppCount")) - 1;
                localStorage.setItem("PFSuppCount", JSON.stringify(suppcount));
                localStorage.setItem("PFSupplier", JSON.stringify(PFSuppl));
                if (suppcount == 0) {
                    this.CatClearClick("SUP");
                }
            }

            if (suppcount > 0) {
                $("#categoryDIVid").addClass("disabledbutton");
                this.setState({ catORsupp: "S", selectallSup: selectAll });
            }
            else {
                $("#categoryDIVid").removeClass("disabledbutton");
                this.setState({ catORsupp: "", selectallSup: selectAll });
            }
        }
        else if (filter == "mfg") {

            let PFM = this.state.PFManufacturer;

            let selectedMFG = [];

            if ($(`#mfg${index + 1}`).prop('checked') == true) {
                let loc = this.state.MFGchecked;

                if (!this.state.viewmfg) {
                    PFM[index].checked = true;
                    selectedMFG = PFM.filter((x) => x.checked == true);
                    selectedMFG.forEach((val) => {
                        loc.push({
                            BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                            MFG_ID: val.MFG_ID
                        })
                    })
                    loc = loc.filter((v, i, a) => a.findIndex(t => (t.MFG_ID.trim().toUpperCase() === v.MFG_ID.trim().toUpperCase())) === i)

                    mfgcount = JSON.parse(localStorage.getItem("PFMFGCount")) + 1;
                    this.setState({ MFGchecked: loc, PFManufacturer: PFM });
                    localStorage.setItem("PFMFGCount", JSON.stringify(mfgcount));
                    localStorage.setItem("PFMFG", JSON.stringify(loc));
                    localStorage.setItem("PFAllMFG", JSON.stringify(PFM));
                }
                else {

                    let MfgIndex = PFM.findIndex((x) => x.MFG_ID == v.MFG_ID)
                    PFM[MfgIndex].checked = true;
                    selectedMFG = PFM.filter((x) => x.checked == true);
                    selectedMFG.forEach((val) => {
                        loc.push({
                            BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                            MFG_ID: val.MFG_ID
                        })
                    })
                    loc = loc.filter((v, i, a) => a.findIndex(t => (t.MFG_ID.trim().toUpperCase() === v.MFG_ID.trim().toUpperCase())) === i)

                    mfgcount = JSON.parse(localStorage.getItem("PFMFGCount")) + 1;
                    this.setState({ MFGchecked: loc, PFManufacturer: PFM });
                    localStorage.setItem("PFMFGCount", JSON.stringify(mfgcount));
                    localStorage.setItem("PFMFG", JSON.stringify(loc));
                    localStorage.setItem("PFAllMFG", JSON.stringify(PFM));
                }

            }
            else {
                if (!this.state.viewmfg) {

                    PFM[index].checked = false;
                    mfgcount = JSON.parse(localStorage.getItem("PFMFGCount")) - 1;
                    let value = v.MFG_ID;
                    let loc = [];
                    selectedMFG = this.state.MFGchecked.filter((x) => x.MFG_ID != value);
                    selectedMFG.forEach((val) => {
                        loc.push({
                            BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                            MFG_ID: val.MFG_ID
                        })
                    })
                    this.setState({ MFGchecked: loc, PFManufacturer: PFM });

                    localStorage.setItem("PFMFGCount", JSON.stringify(mfgcount));
                    localStorage.setItem("PFMFG", JSON.stringify(PFM));
                    localStorage.setItem("PFAllMFG", JSON.stringify(PFM));
                }
                else {
                    if (PFM.length > 0) {
                        let MfgIndex = PFM.findIndex((x) => x.MFG_ID == v.MFG_ID)
                        PFM[MfgIndex].checked = false;
                    }
                    mfgcount = JSON.parse(localStorage.getItem("PFMFGCount")) - 1;
                    let value = v.MFG_ID;
                    let loc = [];
                    selectedMFG = this.state.MFGchecked.filter((x) => x.MFG_ID != value);
                    selectedMFG.forEach((val) => {
                        loc.push({
                            BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                            MFG_ID: val.MFG_ID
                        })
                    })
                    this.setState({ MFGchecked: loc, PFManufacturer: PFM });

                    localStorage.setItem("PFMFGCount", JSON.stringify(mfgcount));
                    localStorage.setItem("PFMFG", JSON.stringify(PFM));
                    localStorage.setItem("PFAllMFG", JSON.stringify(PFM));
                }

            }
            //if (localStorage.getItem("PFMFG") == null) {
            //    localStorage.setItem("PFMFG", JSON.stringify(PFM));
            //}
        }
        //else if (filter == "selectedmfg") {
        //    //PFM[index].checked = false;
        //    let selectedMFG = [];
        //    mfgcount = JSON.parse(localStorage.getItem("PFMFGCount")) - 1;
        //    let value = v.MFG_ID;
        //    let loc = [];
        //    selectedMFG = this.state.MFGchecked.filter((x) => x.MFG_ID != value);
        //    selectedMFG.forEach((val) => {
        //        loc.push({
        //            BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
        //            MFG_ID: val.MFG_ID
        //        })
        //    })
        //    this.setState({ MFGchecked: loc });
        //    localStorage.setItem("PFMFGCount", JSON.stringify(mfgcount));
        //    localStorage.setItem("PFMFG", JSON.stringify(loc));
        //}
    }

    SupplierBind = () => {
        let PFSupplierList = localStorage.getItem("PFSupplier")
        if (PFSupplierList != null) {
            let search = $(`#supplierid`).val()
            //WW-633_PC_06 (2/24/2023)-Aparna
            if (search != "" && search != " " && search != undefined) {
                supplierPresent = false
            }
            PFSupplierList = JSON.parse(localStorage.getItem("PFSupplier"));
            if (this.state.viewsup == false) {
                return PFSupplierList.map((val, index) => {
                    let t = val.checked == false || val.checked == undefined ? false : true;
                    if (search != "" && search != " " && search != undefined) {
                        if (val.NAME1.toUpperCase().includes(search.toUpperCase())) {
                            supplierPresent = true
                            return (
                                <div className="custom-control custom-checkbox my-2 item-custom-control custcheck" key={`pfs${index}`}>
                                    <input type="checkbox" className="custom-control-input" id={`supp${index + 1}`} name="example1" checked={t} onChange={(event) => this.selectOrder(event, index, "supplier", val)} />
                                    <label className="custom-control-label priority-checkbox filter-checkbox" style={{ textTransform: "uppercase" }} htmlFor={`supp${index + 1}`}>{val.NAME1}</label>
                                </div>
                            )
                        }
                    }
                    else {
                        supplierPresent = true
                        return (
                            <div className="custom-control custom-checkbox my-2 item-custom-control custcheck" key={`pfs${index}`}>
                                <input type="checkbox" className="custom-control-input" id={`supp${index + 1}`} name="example1" checked={t} onChange={(event) => this.selectOrder(event, index, "supplier", val)} />
                                <label className="custom-control-label priority-checkbox filter-checkbox" style={{ textTransform: "uppercase" }} htmlFor={`supp${index + 1}`}>{val.NAME1}</label>
                            </div>
                        )
                    }
                });
            }
            //To display the selected supplier boxes alone
            else {
                return PFSupplierList.map((val, index) => {
                    let t = val.checked == false || val.checked == undefined || val.checked == null ? false : true;
                    if (t == true) {
                        supplierPresent = true
                        return (
                            <div className="custom-control custom-checkbox my-2 item-custom-control custcheck" >
                                <input type="checkbox" className="custom-control-input" id={`supp${index + 1}`} name="example1" checked={t} onChange={(event) => this.selectOrder(event, index, "supplier", val)} />
                                <label className="custom-control-label priority-checkbox filter-checkbox" style={{ textTransform: "uppercase" }} htmlFor={`supp${index + 1}`} >{val.NAME1}</label>
                            </div>)
                    }
                });
                this.setState({ viewsup: false });
            }
        }
    }



    //WW-633_PC_11 (2/24/2023)-Aparna
    suppliersearch = () => {
        this.SupplierBind();
        this.setState({ supsearch: $(`#supplierid`).val(), selectallSup: true });
    }
    selectedmfgBind = () => {
        let PFselectedmfg = localStorage.getItem("PFMFG")
        if ($('#getMFG').val() == "") {
            if (PFselectedmfg != null) {
                PFselectedmfg = JSON.parse(localStorage.getItem("PFMFG"));
                return PFselectedmfg.map((val, index) => {
                    let t = true;
                    return (
                        <div className="custom-control custom-checkbox my-2 item-custom-control custcheck" key={`selectedmfg${index}`}>
                            <input type="checkbox" className="custom-control-input" id={`selmfg${index + 1}`} name="example1" checked={t} onChange={(event) => this.selectOrder(event, index, "selectedmfg", val)} />
                            <label className="custom-control-label priority-checkbox filter-checkbox" htmlFor={`selmfg${index + 1}`}>{val.MFG_ID}</label>
                        </div>
                    )
                });

            }
        }

    }


    handleChange = (event) => {

        if (event.target.name == "Make") {
            let make = event.target.value;
            let model = []
            let mm = [];
            //const PartList = pageLoadData.PartList.reduce(
            //    (result, item) =>
            //        result.set(
            //            item.ISA_MAKE,
            //            (result.get(item.ISA_MAKE) || []).concat(item)
            //        ),
            //    new Map()
            //);
            mm = this.state.CompletePartList.filter((x) => x.ISA_MAKE == make)
            model = mm.filter((v, i, a) => a.findIndex(t => (t.ISA_MODEL.trim().toUpperCase() === v.ISA_MODEL.trim().toUpperCase())) === i)
            // .
            let isDisableAsset = false;
            if (event.target.value != 0 && event.target.value != "0") {
                $(`#modelid`).prop('disabled', false)
                isDisableAsset = true;

            }
            else {
                $(`#modelid`).prop('disabled', true)
                isDisableAsset = false;
            }
            $('#PartsListErr').addClass('d-none');

            this.setState({ [event.target.name]: event.target.value, ModelList: model, Model: 0, AssetID: 0, isAssetDDDisable: isDisableAsset });
            //localStorage.setItem("Modellist", JSON.stringify(model));
            //let cook = CookieService.getLocalStorageValues("Modellist")
            //cook = JSON.parse(localStorage.getItem("Modellist"));
            //if (cook.length > 0) {
            //    cook = cook[1];
            //}

            // $('#EditAccdordian').attr('data-enabled', 'true')
            // $("#test").addClass("disabledbutton");

        }
        else if (event.target.name == "Model") {
            let make = this.state.Make;
            let model = event.target.value;
            let asset = [];
            let assetdd = [];
            asset = this.state.CompletePartList.filter((x) => x.ISA_MAKE == make && x.ISA_MODEL == model)
            asset.map((val, index) => {
                if (index == 0) {
                    let defaultvalue = {
                        value: "0",
                        label: "--Select Asset ID--"
                    }
                    assetdd.push(defaultvalue)
                }
                let localArray = {
                    value: val.ISA_MACHINE_NO,
                    label: val.ISA_MACHINE_NO
                }

                assetdd.push(localArray)
            });
            let isDisableAsset = false;
            if (event.target.value != 0 && event.target.value != "0") {
                isDisableAsset = false;
            }
            else {
                isDisableAsset = true;
            }
            $('#PartsListErr').addClass('d-none');
            //localStorage.setItem("Model", JSON.stringify(event.target.value));
            this.setState({ [event.target.name]: event.target.value, AssetList: assetdd, AssetID: 0, isAssetDDDisable: isDisableAsset });
        }
        else if (event.target.name == "AssetID") {
            $('#PartsListErr').addClass('d-none');
            if (this.state.Make == "" && this.state.Make == 0) {
                if (this.state.Model == "" && this.state.Model == 0) {
                    let asset = event.target.value;
                    let MM = []
                    MM = this.state.CompletePartList.filter((x) => x.ISA_MACHINE_NO == asset)
                    this.setState({ [event.target.name]: event.target.value, Make: MM[0].ISA_MAKE, Model: MM[0].ISA_MODEL });
                    // localStorage.setItem("AssetId", JSON.stringify(event.target.value));
                }
            }
            else {
                //localStorage.setItem("AssetId", JSON.stringify(event.target.value));               
                this.setState({ [event.target.name]: event.target.value });
            }
        }
        else {
            // localStorage.setItem("AssetId", JSON.stringify(event.target.value));
            this.setState({ [event.target.name]: event.target.value });
        }

    }
    handleChangeAsset = (values) => {
        $('#PartsListErr').addClass('d-none');
        if (this.state.Make == "" || this.state.Make == 0 || this.state.Make == "0") {
            if (this.state.Model == "" || this.state.Model == 0 || this.state.Model == "0") {
                let asset = values;
                let MM = []
                MM = this.state.CompletePartList.filter((x) => x.ISA_MACHINE_NO == values.value)
                let model = []
                let mm = [];
                mm = this.state.CompletePartList.filter((x) => x.ISA_MAKE == MM[0].ISA_MAKE)
                model = mm.filter((v, i, a) => a.findIndex(t => (t.ISA_MODEL.trim().toUpperCase() === v.ISA_MODEL.trim().toUpperCase())) === i)
                $(`#modelid`).prop('disabled', false)
                //localStorage.setItem("AssetId", JSON.stringify(MM[0].ISA_MAKE));
                //localStorage.setItem("AssetId", JSON.stringify(MM[0].ISA_MAKE));
                this.setState({ AssetID: values, Make: MM[0].ISA_MAKE, Model: MM[0].ISA_MODEL, ModelList: model });
            }
        }
        else {
            // localStorage.setItem("AssetId", JSON.stringify(values.value));
            this.setState({ AssetID: values });
        }
    }
    MakeBind = () => {
        if (this.state.MakeList.length > 0) {
            return this.state.MakeList.map((val, index) => {
                return (<option key={val.ISA_MAKE} value={val.ISA_MAKE}>{val.ISA_MAKE}</option>)
            });
        }
    }
    ModelBind = () => {
        let model = this.state.ModelList;
        if (model.length > 0) {
            return model.map((val, index) => {
                return (<option key={val.ISA_MODEL} value={val.ISA_MODEL}>{val.ISA_MODEL}</option>)
            });
        }
    }
    PartSearchClick = () => {
        localStorage.setItem("Make", JSON.stringify(this.state.Make));
        localStorage.setItem("Model", JSON.stringify(this.state.Model));
        localStorage.setItem("AssetId", JSON.stringify(this.state.AssetID.value));
        CookieService.updateLocalStorageValues("searchKey", "");
        if (this.state.Make != "0" && this.state.Model != "0" && this.state.AssetID.value != "0") {
            let Make = this.state.Make
            Make = Make.replace(/&/g, "%26")
            Make = Make.replace(/#/g, "%23")
            let Model = this.state.Model
            Model = Model.replace(/&/g, "%26")
            Model = Model.replace(/#/g, "%23")
            this.props.history.push({
                pathname: `\searchresults`,
                search: `?key=&Make=${Make.trim()}&Model=${Model.trim()}&AssetId=${this.state.AssetID.value}`,
                state: { ImageSearch: false, ImageFiles: "", image: "" }
            });
        } else {
            $('#PartsListErr').removeClass('d-none');
        }
    };


    PartClearClick = () => {

        localStorage.removeItem("Make");
        localStorage.removeItem("Model");
        localStorage.removeItem("AssetId");
        let assetdd = [];
        let defaultvalue = {
            value: "0",
            label: "--Select Asset ID--"
        }
        assetdd.push(defaultvalue)
        let PartList = this.state.CompletePartList;
        PartList.forEach((x) => {
            let localArray = {
                value: x.ISA_MACHINE_NO,
                label: x.ISA_MACHINE_NO
            }
            assetdd.push(localArray)
        });
        $(`#modelid`).prop('disabled', true)
        this.setState({ Make: "0", ModelList: [], Model: "0", AssetID: defaultvalue, AssetList: assetdd, isAssetDDDisable: false });
    }
    CatClearClick = (id) => {
        let CAT = [];
        let PFCcount = JSON.parse(localStorage.getItem("PFCatCount"));
        let PFScount = JSON.parse(localStorage.getItem("PFSuppCount"));
        let PFMcont = JSON.parse(localStorage.getItem("PFMFGCount"));
        if (id == "CAT") {
            CAT = this.state.PFCategory
            CAT.forEach((x) => {
                x.checked = false;
            })
            //WW-633_PC_07 (2/24/2023)-Aparna
            if (PFCcount >= 0) {
                if (localStorage.getItem("PFCategory") != null) {

                    localStorage.setItem("PFCategory", JSON.stringify(CAT));
                    localStorage.setItem("PFCatCount", JSON.stringify(0));
                    this.setState({ PFCategory: CAT, selectallCat: true, viewcat: false });
                }
                else {

                    this.setState({ PFCategory: CAT, selectallCat: true, viewcat: false })
                }
            }
            else {

                this.setState({ PFCategory: CAT, selectallCat: true, viewcat: false })
            }

        }
        else if (id == "SUP") {
            CAT = this.state.PFSupplier
            CAT.forEach((x) => {
                x.checked = false;
            })
            if (PFCcount >= 0) {
                if (localStorage.getItem("PFSupplier") != null) {

                    localStorage.setItem("PFSupplier", JSON.stringify(CAT));
                    localStorage.setItem("PFSuppCount", JSON.stringify(0));
                    this.setState({ PFSupplier: CAT, selectallSup: true, viewsup: false });
                }
                else {

                    this.setState({ PFSupplier: CAT, selectallSup: true, viewsup: false })
                }
            }
            else {

                this.setState({ PFSupplier: CAT, selectallSup: true, viewsup: false })
            }
        }
        else if (id == "MFG") {
            CAT = []
            let mfg = this.state.PFManufacturer
            mfg.forEach((x) => {
                x.checked = false;
            })
            localStorage.setItem("PFAllMFG", JSON.stringify(mfg));
            if (PFMcont > 0) {
                if (localStorage.getItem("PFMFG") != null) {

                    localStorage.setItem("PFMFG", JSON.stringify([]));
                    localStorage.setItem("PFMFGCount", JSON.stringify(0));
                    this.setState({ selectedMFG: CAT, MFGchecked: CAT, viewmfg: false, selectallMfg: true });
                }
                else {

                    this.setState({ selectedMFG: CAT, PFManufacturer: mfg, viewmfg: false, selectallMfg: true });
                }
            }
            else {

                this.setState({ selectedMFG: CAT, viewmfg: false, selectallMfg: true })
            }
        }
    }
    ClearMfg = () => {

        let mfg = this.state.MFGArray;
        mfg.forEach((x) => {
            x.checked = false;
        })
        //localStorage.setItem("PFAllMFG", JSON.stringify(mfg));
        CookieService.updateLocalStorageValues("PFMFGCount", 0)
        CookieService.updateLocalStorageValues("PFMFG", [])
        this.setState({ selectedMFG: [], ViewMfgList: [], viewmfg: false, selectallMfg: true, MFGSelectedCount: 0 });

    }
    SelectMfgOrder = (e, index, mfg, val) => {

        let ManuPF = this.state.MFGArray;
        let ViewMfg = this.state.ViewMfgList;

        let selectMfgCount = ViewMfg.length > 0 ? ViewMfg.length : 0;

        let selectedMFG = [];
        if (mfg == "viewmfg") {
            if ($(`#mfg${index + 1}`).prop('checked') == false) {
                if (ManuPF.length > 0) {
                    let MfgIndex = ManuPF.findIndex((x) => x.MFG_ID.toUpperCase() == val.MFG_ID.toUpperCase())
                    if (MfgIndex != -1) {
                        ManuPF[MfgIndex].checked = false;
                    }

                }
                selectMfgCount = selectMfgCount - 1;
                let value = val.MFG_ID;
                let loc = [];
                selectedMFG = ViewMfg.filter((x) => x.MFG_ID.toUpperCase() != value.toUpperCase());
                selectedMFG.forEach((val) => {
                    loc.push({
                        BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                        MFG_ID: val.MFG_ID.toUpperCase()
                    })
                })
                CookieService.updateLocalStorageValues("PFMFGCount", selectMfgCount)
                CookieService.updateLocalStorageValues("PFMFG", loc)
                this.setState({ ViewMfgList: loc, MFGArray: ManuPF, MFGSelectedCount: selectMfgCount });
            }

        }
        else {
            if ($(`#mfg${index + 1}`).prop('checked') == true) {
                ManuPF[index].checked = true;
                selectedMFG = ManuPF.filter((x) => x.checked == true);
                let locselectallMfg = this.state.selectallMfg;
                if (ManuPF.length == selectedMFG.length) {
                    locselectallMfg = false
                }
                let loc = this.state.ViewMfgList;
                selectedMFG.forEach((val) => {
                    loc.push({
                        BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                        MFG_ID: val.MFG_ID.toUpperCase()
                    })
                })
                loc = loc.filter((v, i, a) => a.findIndex(t => (t.MFG_ID.trim().toUpperCase() === v.MFG_ID.trim().toUpperCase())) === i)

                selectMfgCount = selectMfgCount + 1;
                CookieService.updateLocalStorageValues("PFMFGCount", selectMfgCount)
                CookieService.updateLocalStorageValues("PFMFG", loc)
                this.setState({ ViewMfgList: loc, MFGArray: ManuPF, MFGSelectedCount: selectMfgCount, selectallMfg: locselectallMfg });
            }
            else {
                ManuPF[index].checked = false;
                selectMfgCount = selectMfgCount - 1;
                let filtered = ManuPF.filter((x) => x.checked == false);
                let locselectallMfg = this.state.selectallMfg;
                if (ManuPF.length == filtered.length) {
                    locselectallMfg = true
                }
                let value = val.MFG_ID;
                let loc = [];
                selectedMFG = ViewMfg.filter((x) => x.MFG_ID.toUpperCase() != value.toUpperCase());
                selectedMFG.forEach((val) => {
                    loc.push({
                        BUSINESS_UNIT_OM: val.BUSINESS_UNIT_OM,
                        MFG_ID: val.MFG_ID.toUpperCase()
                    })
                })
                CookieService.updateLocalStorageValues("PFMFGCount", selectMfgCount)
                CookieService.updateLocalStorageValues("PFMFG", loc)
                this.setState({ ViewMfgList: loc, MFGArray: ManuPF, MFGSelectedCount: selectMfgCount, selectallMfg: locselectallMfg });
            }
        }
    }
    PFManufacturerBind = () => {
        if (this.state.viewmfg) {
            let ViewMfgarray = this.state.ViewMfgList;
            if (ViewMfgarray != null && ViewMfgarray.length > 0) {
                return ViewMfgarray.map((val, index) => {
                    let t = true
                    return (
                        <div className="custom-control custom-checkbox my-2 item-custom-control custcheck">
                            <input type="checkbox" className="custom-control-input" id={`mfg${index + 1}`} name="example1" checked={t} onChange={(event) => this.SelectMfgOrder(event, index, "viewmfg", val)} />
                            <label className="custom-control-label priority-checkbox filter-checkbox" style={{ textTransform: "uppercase" }} htmlFor={`mfg${index + 1}`}>{val.MFG_ID}</label>
                        </div>)
                });
            }
        }
        else {
            if (this.state.MFGArray.length > 0) {
                return this.state.MFGArray.map((val, index) => {

                    let t = val.checked == false || val.checked == undefined ? false : true;
                    return (
                        <div className="custom-control custom-checkbox my-2 item-custom-control custcheck">
                            <input type="checkbox" className="custom-control-input" id={`mfg${index + 1}`} name="mfgcheck" checked={t} onChange={(event) => this.SelectMfgOrder(event, index, "mfg", val)} />
                            <label className="custom-control-label priority-checkbox filter-checkbox" htmlFor={`mfg${index + 1}`}>{val.MFG_ID}</label>
                        </div>
                    )
                });
            }
        }
    }
    ManufacturerBind = () => {
        //let selectedmfg = JSON.parse(localStorage.getItem("PFMFG"));
        let selectedmfg = this.state.MFGchecked;
        //To display only the selected mfg boxes
        if (this.state.viewmfg == true) {
            if (selectedmfg != null) {
                return selectedmfg.map((val, index) => {
                    let t = true
                    //WW-633_PC_08 id-sup is changed to'mfg' (2/24/2023)-Aparna
                    return (
                        <div className="custom-control custom-checkbox my-2 item-custom-control custcheck">
                            <input type="checkbox" className="custom-control-input" id={`mfg${index + 1}`} name="example1" checked={t} onChange={(event) => this.selectOrder(event, index, "mfg", val)} />
                            <label className="custom-control-label priority-checkbox filter-checkbox" style={{ textTransform: "uppercase" }} htmlFor={`mfg${index + 1}`}>{val.MFG_ID}</label>
                        </div>)
                });
            }

        }
        else {
            if (this.state.PFManufacturer.length > 0) {
                return this.state.PFManufacturer.map((val, index) => {

                    let t = val.checked == false || val.checked == undefined ? false : true;
                    return (
                        <div className="custom-control custom-checkbox my-2 item-custom-control custcheck">
                            <input type="checkbox" className="custom-control-input" id={`mfg${index + 1}`} name="mfgcheck" checked={t} onChange={(event) => this.selectOrder(event, index, "mfg", val)} />
                            <label className="custom-control-label priority-checkbox filter-checkbox" htmlFor={`mfg${index + 1}`}>{val.MFG_ID}</label>
                        </div>
                    )
                });
            }
        }

    }

    getMFGList = () => {
        let ip = $('#getMFG').val();
        if (ip != "") {
            let BO = {
                Type: "MANUFACTURER",
                SearchText: ip.toUpperCase(),
                BU: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            HomepageAction.GetMFG(BO);
            this.setState({ viewmfg: false });
        }
        else {

            this.setState({ MFGArray: [] });
            //this.selectedmfgBind();
        }

    }
    closeicon = (id) => {
        if (id == "MFG") {
            if ($('#getMFG').val() == "") {
                $('#manuclose').addClass('d-none');
            }
            else {
                $('#manuclose').removeClass('d-none');
            }

        } else if (id == "CAT") {
            if ($('#categoryid').val() == "") {
                $('#catclose').addClass('d-none');
            }
            else {
                $('#catclose').removeClass('d-none');
            }
        }
        else if (id == "SUP") {
            if ($('#supplierid').val() == "") {
                $('#supclose').addClass('d-none');
            }
            else {
                $('#supclose').removeClass('d-none');
            }
        }



    }
    catcloseicon = () => {



    }
    supcloseicon = () => {

    }

    assignMFG = () => {

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        //if (localStorage.getItem("PFMFG") == null) {
        //    localStorage.setItem("PFMFG", JSON.stringify(category));
        //}
        let pageLoadData = JSON.parse(HomepageStore.pageLoadData);
        if (pageLoadData) {
            if (pageLoadData.Table.length > 0) {
                pageLoadData.Table.map((x, index) => {
                    pageLoadData.Table[index].checked = false;
                    let viewIndex = this.state.ViewMfgList.findIndex(t => (t.MFG_ID.trim().toUpperCase() === x.MFG_ID.trim().toUpperCase()))
                    if (viewIndex != -1) {
                        pageLoadData.Table[index].checked = true;
                    }
                })
                this.setState({ MFGArray: pageLoadData.Table, selectallMfg: true });
                //if (localStorage.getItem("PFMFG") != null) {
                //    let mfg = [];
                //    let selectedmfg = JSON.parse(localStorage.getItem("PFMFG"));
                //    pageLoadData.Table.map((x, index) => {
                //        selectedmfg.map((y) => {
                //            if (x.MFG_ID == y.MFG_ID) {
                //                pageLoadData.Table[index].checked = true;
                //            }
                //        })

                //    })

                //    this.setState({ PFManufacturer: pageLoadData.Table, selectallMfg: true });
                //}
                //else {
                //    this.setState({ PFManufacturer: pageLoadData.Table, selectallMfg: true });

                //}
            }
            else {
                this.setState({ MFGArray: [] });
            }
        }

    }
    //ww-643- search pikup [3/13/2023]-PAVITHRA R
    pickupchange = (Type) => {
        let pickUp = false
        let deliveryShipTo = false
        let pickupCheck = false
        if (Type != 1) {
            pickupCheck = true
            pickUp = true
            deliveryShipTo = false
            localStorage.setItem("pickupcheck", true);

        }
        else {
            pickUp = false
            deliveryShipTo = true
            pickupCheck = false
            localStorage.setItem("pickupcheck", false);
        }
        CookieService.updateLocalStorageValues("Shipment_Method", true)
        this.setState({
            pickUp: pickUp, deliveryShipTo: deliveryShipTo, pickupCheck: pickupCheck
        })


    }


    InventoryCheck = (e) => {
        if (e.target.checked) {

            this.setState({ inventorycheck: true });
            localStorage.setItem("inventorycheck", true);
        }
        else {

            this.setState({ inventorycheck: false });
            localStorage.setItem("inventorycheck", false);
        }
    }
    cleariconclick = (id) => {
        let lable = "";

        if (id == "MFG") {
            $('#getMFG').val('');
            $('#manuclose').addClass('d-none');
        }
        else if (id == "CAT") {
            $('#categoryid').val('');
            $('#catclose').addClass('d-none');
            this.setState({ catsearch: "" });
        }
        else if (id == "SUP") {
            $('#supplierid').val('');
            $('#supclose').addClass('d-none');
            this.setState({ supsearch: "" });
        }

    }
    WorkOrderResponse = () => {
        localStorage.setItem('WONum', this.state.WONum);
        let loacalloc = ""
        let localWON = ""
        let BilltoStoreLocationLat = ""
        let BilltoStoreLocationLong = ""
        let Workorderresponse = JSON.parse(HomepageStore.workorderresponse);
        if (Workorderresponse.WOResponse.length > 0) {
            if (Workorderresponse.WOResponse[0].AssetID != "" && Workorderresponse.WOResponse[0].AssetID != null && Workorderresponse.WOResponse[0].AssetID != undefined && Workorderresponse.WOResponse[0].AssetID != " ") {
                localStorage.setItem('WOAssetID', Workorderresponse.WOResponse[0].AssetID);
                localStorage.setItem('WOAssetTag', Workorderresponse.WOResponse[0].AssetTag);
                if (Workorderresponse.WOResponse[0].WO_Make != "" && Workorderresponse.WOResponse[0].WO_Make != null && Workorderresponse.WOResponse[0].WO_Make != undefined && Workorderresponse.WOResponse[0].WO_Make != " ") {
                    CookieService.updateLocalStorageValues("WO_Make", Workorderresponse.WOResponse[0].WO_Make);
                } if (Workorderresponse.WOResponse[0].WO_Model != "" && Workorderresponse.WOResponse[0].WO_Model != null && Workorderresponse.WOResponse[0].WO_Model != undefined && Workorderresponse.WOResponse[0].WO_Model != " ") {
                    CookieService.updateLocalStorageValues("WO_Model", Workorderresponse.WOResponse[0].WO_Model);
                }
            }
            if (Workorderresponse.WOResponse[0].LOCATION != "" && Workorderresponse.WOResponse[0].LOCATION != null && Workorderresponse.WOResponse[0].LOCATION != undefined && Workorderresponse.WOResponse[0].LOCATION != " ") {
                loacalloc = Workorderresponse.WOResponse[0].LOCATION
                localStorage.setItem("StoreValue", JSON.stringify(loacalloc));
                BilltoStoreLocationLat = Workorderresponse.WOResponse[0].LATITUDE;
                BilltoStoreLocationLong = Workorderresponse.WOResponse[0].LONGITUDE;
                localStorage.setItem("BilltoStoreLocationLat", BilltoStoreLocationLat);
                localStorage.setItem("BilltoStoreLocationLong", BilltoStoreLocationLong);
                console.log("loacalloc", loacalloc);
            }
            if (Workorderresponse.WOResponse[0].Notes != "" && Workorderresponse.WOResponse[0].Notes != null && Workorderresponse.WOResponse[0].Notes != undefined && Workorderresponse.WOResponse[0].Notes != " ") {
                localWON = Workorderresponse.WOResponse[0].Notes;
                //$("#AssetID").attr("disabled", true);
                console.log("Notes", Workorderresponse.WOResponse[0].Notes);

            }
            CookieService.updateLocalStorageValues("Trade", Workorderresponse.WOResponse[0].Trade);
            let homestoreloc = CookieService.getLocalStorageValues("LOCATION");
            CookieService.updateLocalStorageValues("homestoreloc", homestoreloc);
            CookieService.updateLocalStorageValues("LOCATION", Workorderresponse.WOResponse[0].COUNTRY);
            CookieService.updateLocalStorageValues("WO_Address", Workorderresponse.WOResponse[0].ADDRESS1);
            localStorage.setItem("Country", Workorderresponse.WOResponse[0].COUNTRY);
            CookieService.updateLocalStorageValues("WO_Category", Workorderresponse.WOResponse[0].Category);
            CookieService.updateLocalStorageValues("WO_Priority", Workorderresponse.WOResponse[0].Priority);
            CookieService.updateLocalStorageValues("NTEAmount", Workorderresponse.WOResponse[0].NTE);
            CookieService.updateLocalStorageValues("WO_CAT_DESC", Workorderresponse.WOResponse[0].WO_CAT_DESC);
            CookieService.updateLocalStorageValues("WO_Type", Workorderresponse.WOResponse[0].WO_Type);
            CookieService.updateLocalStorageValues("Session_WO_STATE", Workorderresponse.WOResponse[0].STATE); //WW-1231 WO State Restriction -Vishwa S
            CookieService.updateLocalStorageValues("IsBlanketWO", Workorderresponse.WOResponse[0].IsBlanketWO); // Set stating the location as the IsblanketWO if the user selects the W09301 location

            //WW-1374 Update the WO logo, Problem code long and short description to cookie - Nandhini L 
            CookieService.updateLocalStorageValues("Logo", Workorderresponse.WOResponse[0].Logo);
            CookieService.updateLocalStorageValues("ProblemCodeDescription", Workorderresponse.WOResponse[0].ProblemCodeDescription);
            CookieService.updateLocalStorageValues("Description", Workorderresponse.WOResponse[0].Description);

            if (Workorderresponse.WOParts != undefined && Workorderresponse.WOParts != null) {

                if (Workorderresponse.WOParts.length > 0) {
                    // CookieService.updateLocalStorageValues("WO_Parts", JSON.stringify(Workorderresponse.WOParts));
                    localStorage.setItem("WO_Parts", JSON.stringify(Workorderresponse.WOParts)) //BUG:3618 -Aparna


                }
            }
        }
        let equipmentVariable = localStorage.getItem("isEquipmentClick")
        let noncatVariable = localStorage.getItem("isNoncatClick")
        let interactiveVariable = localStorage.getItem("isInteractiveClick")
        if (noncatVariable == "true") {
            localStorage.setItem('isNoncatClick', "false");
            this.noncat();

        }
        //WW-1163 Interactive diagram navigation check -Vishwa S
        else if (interactiveVariable == "true") {
            localStorage.setItem('isInteractiveClick', "false");
            this.headerRedirect("", "/interactivediagram");
        } else if (equipmentVariable == "true") {
            localStorage.setItem('isEquipmentClick', "false");
            this.headerRedirect("", "/Equipments");
        }
        else if (this.state.IsProblemCodeSearch == true) {
            //WW-1374 problem code search - Nandhini L 
            CookieService.updateLocalStorageValues("IsProblemCodeSearch", true);
            CookieService.updateLocalStorageValues("Shipment_Method", true);
            $('#Delivery_Method').modal('hide');
            this.searchClick("IsProblemCodeSearch")
        }
        else {
            this.TechVault();
        }
    }
    noncatClick = (e) => {
        let WO = localStorage.getItem("WONum")
        localStorage.setItem('isNoncatClick', "true");

        if (WO != undefined && WO != null && WO.trim() != "") {
            this.noncat(e);
        }
        else {
            $('#WorkOrderPopUpHome').modal('show');
            e.preventDefault();
        }
    }

    noncat = (event) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let IsThirdParty = CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false;
        let WO_Type = CookieService.getLocalStorageValues("WO_Type") != "" && CookieService.getLocalStorageValues("WO_Type") != null ? CookieService.getLocalStorageValues("WO_Type") : "";

        if (WO_Type.toUpperCase() != 'WALMART' && IsThirdParty != false) {
            this.headerRedirect(event, "/RFQEntry")
        }
        else {
            this.headerRedirect(event, "/WalmartRFQEntry")
        }

    }

    //WW-1163 Method to check for #WO and interactive diagram navigation -Vishwa S
    interactiveClick = (e) => {
        let WO = localStorage.getItem("WONum")
        localStorage.setItem('isInteractiveClick', "true");

        if (WO != undefined && WO != null && WO.trim() != "") {
            this.headerRedirect(e, "/interactivediagram/")
        }
        else {
            $('#WorkOrderPopUpHome').modal('show');
            e.preventDefault();
        }
    }

    WorkOrderFail = () => {
        const { t } = this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.setState({ WOErrorMsg: t("Please enter a valid work order #") });
        //WW-1374 problem code search - Nandhini L 
        if (this.state.IsProblemCodeSearch == true) {
            $('#Delivery_Method').modal('show');
        } else {
            $('#WorkOrderPopUpHome').modal('show');
        }
    }
    KeyPress = (e) => {
        if (e.keyCode == 13) {
            this.ValidateWO();
        }
    }
    ValidateWO = () => {
        const { t } = this.props
        if (this.state.WONum.trim() != "") {
            if (CookieService.getLocalStorageValues("Session_CC_VALIDATE_WO") != 'N') {
                let WorkOrderBO = {
                    workOrder: this.state.WONum,
                    Session_THIRDPARTY_COMP_ID: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "" ? CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") : "",
                    User_Type: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    is_WO_Parts_Needed: true
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                $('#WorkOrderPopUpHome').modal('hide');
                HomepageAction.WorkOrderCheck(WorkOrderBO)
            }
            else {
                localStorage.setItem('WONum', this.state.WONum);
                $("#WorkOrderNo").addClass("disabledbutton");
                let equipmentVariable = localStorage.getItem("isEquipmentClick")
                let noncatVariable = localStorage.getItem("isNoncatClick")
                let interactiveVariable = localStorage.getItem("isInteractiveClick")
                if (noncatVariable == "true") {
                    localStorage.setItem('isNoncatClick', "false");
                    this.noncat();
                }
                else if (interactiveVariable == "true") {
                    localStorage.setItem('isInteractiveClick', "false");
                    this.headerRedirect("", "/interactivediagram");
                } else if (equipmentVariable == "true") {
                    localStorage.setItem('isEquipmentClick', "false");
                    this.headerRedirect("", "/Equipments");
                }
                else if (this.state.IsProblemCodeSearch == true) {
                    //WW-1374 problem code search - Nandhini L 
                    CookieService.updateLocalStorageValues("IsProblemCodeSearch", true);
                    CookieService.updateLocalStorageValues("Shipment_Method", true);
                    $('#Delivery_Method').modal('hide');
                    this.searchClick("IsProblemCodeSearch")
                }
                else {
                    this.TechVault();
                }
                $('#WorkOrderPopUpHome').modal('hide');
            }
        }
        else {
            this.setState({ WOErrorMsg: t("Please enter work order #") })
        }

    }
    WONumChange = (e) => {
        const NumRegex = SDIConstants.quantityRegEX;
        if (e.target.value === '' || NumRegex.test(e.target.value)) {
            this.setState({ WONum: e.target.value, WOErrorMsg: "" });
        }
    }
    ClearWO = () => {
        //WW-1374 problem code search - Nandhini L 
        localStorage.removeItem('WONum')
        this.setState({ WONum: "", WOErrorMsg: "" });
    }
    WOClose = () => {
        $('#WorkOrderPopUpHome').modal('hide');
        localStorage.setItem('isNoncatClick', "false");
        localStorage.setItem('isInteractiveClick', "false");
        localStorage.setItem('isEquipmentClick', "false");
        this.setState({ WONum: "", WOErrorMsg: "" });
    }
    /*[08/31/22 , PC_365_01]Tech Vault Search - Priyanka D*/
    TechVault = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let techVaultBO = {
            //[01/30/2024, WW-942] open tech vault without search value - Nandhini L
            //AssetID: localStorage.getItem("WOAssetID"),
            //Tradename: CookieService.getLocalStorageValues("Trade"),
            AssetID: "",
            Tradename: "",
            WO_Type: CookieService.getLocalStorageValues("WO_Type")
        }
        HomepageAction.TechVault(techVaultBO)
    }
    PassAuthe = (event) => {
        event.preventDefault()
        let customFields = []
        let PassAutheBO = {
            UserID: CookieService.getLocalStorageValues("Session_AGENTUSERID") == "" ? CookieService.getLocalStorageValues("Session_UserID") : CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            UserBu: CookieService.getLocalStorageValues("Session_AGENTUSERBU") == "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            EmailID: CookieService.getLocalStorageValues("Session_EMAIL"),
            IsThirdParty: CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != "0" && CookieService.getLocalStorageValues("Session_THIRDPARTY_COMP_ID") != null ? true : false,
            PassWord: "",
            OrderNumber: "",
            PONumber: "",
            HomepageRequest: true,
            customFields: customFields
        }
        HomepageAction.getPassThroughAutheURl(PassAutheBO)
    }
    PassThroughAutheResponse = () => {
        let URl = JSON.parse(HomepageStore.PassThroughAuthe)
        window.open(URl);
        /*[12/010/21, PC_HC_01], Priyanka D//Used PreventDefault inorder to prevent multiple window opening*/
        window.preventDefault();
    }
    changeon = (e) => {
        // this.setState({ [e.target.name]: e.target.value });
    }
    handleImageClick = () => {
        let Shipment_Method = CookieService.getLocalStorageValues("Shipment_Method")// Custom validation function for shipment
        if (Shipment_Method) {

            this.fileInputRef.current.click();

        } else {
            IsImageSearch = true
            $('#Delivery_Method').modal('show');
        }
        this.setState({
            productData: [], suggestionData: [],
        });
    }
    handleFileChange = (event) => {
        const { t } = this.props
        let file = event.target.files;

        //WW-1374 Update problem code search as false for image search - Nandhini L
        CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);
        this.setState({ IsProblemCodeSearch: false });

        if (file) {
            if (file.length == 1) {
                // IsImageSearch = true
                //WW-1378_WW-1382- Update search properties to new state - Nandhini L
                CookieService.updateLocalStorageValues('fromSearch', false);
                CookieService.updateLocalStorageValues('pageNo', "");
                CookieService.updateLocalStorageValues('GridType', "");
                CookieService.updateLocalStorageValues('pageCount', "");
                CookieService.updateLocalStorageValues("searchKey", "");
                CookieService.updateLocalStorageValues("ImageSearch", "");
                CookieService.updateLocalStorageValues("FilePath", "");
                CookieService.updateLocalStorageValues("FileName", "");
                CookieService.updateLocalStorageValues("SearchUrl", "");

                CookieService.updateLocalStorageValues("Shipment_Method", true)
                files = event.target.files[0]
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                this.props.history.push({
                    pathname: `\searchresults`,
                    search: `?key=`,
                    state: { ImageSearch: true, ImageFiles: file, image: files }
                });
                //    NonCatalogAction.addAttachment(file);
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: t("You can choose only one Image")
                });

            }
        }
        else {
            IsImageSearch = false
            // Handle cancel click here

        }


    }

    OnClickSearchType = (value) => {
        CookieService.updateLocalStorageValues("SearchType", value);
        this.setState({ SearchType: value, productData: null, suggestionData: null });
        this.retrieveDataAsynchronously(this.state.autoCompleteValue);
    }

    //WW-1374 problem code search - Nandhini L 
    onChangePC = (e) => {
        const isChecked = e.target.checked;
        let Shipment_Method = CookieService.getLocalStorageValues("Shipment_Method")

        if (isChecked) {
            const woNum = localStorage.getItem("WONum");

            if (woNum && Shipment_Method == true) {
                CookieService.updateLocalStorageValues("IsProblemCodeSearch", true);
                $('#Delivery_Method').modal('hide');
                this.searchClick("IsProblemCodeSearch");
                return
            }
            this.setState({ IsProblemCodeSearch: true });
            $('#Delivery_Method').modal('show');
        } else {
            CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);
            this.setState({ IsProblemCodeSearch: false });
        }
    }

    PcPopupBtnClick = (Type) => {
        let woNum = localStorage.getItem("WONum") ? localStorage.getItem("WONum") : "";
        if (Type === 'Cancel') {
            $('#Delivery_Method').modal('hide');
            IsImageSearch = false
            document.getElementById("shipmentmethoderrorid").innerText = ""
            CookieService.updateLocalStorageValues("Shipment_Method", false);
            CookieService.updateLocalStorageValues("IsProblemCodeSearch", false);

            localStorage.setItem("pickupcheck", false);

            this.setState({ pickUp: false, deliveryShipTo: true, WONum: woNum, WOErrorMsg: false, IsProblemCodeSearch: false });
        }
        else if (Type === 'Apply') {
            $('#Delivery_Method').modal('hide');

            if (woNum) {
                CookieService.updateLocalStorageValues("Shipment_Method", true);
                CookieService.updateLocalStorageValues("IsProblemCodeSearch", true);
                this.searchClick("IsProblemCodeSearch");
            } else {
                this.ValidateWO();
            }
        }

    }


    /*****END***************** */
    render() {

        //WW-1374 problem code search - Nandhini L 
        let woNum = localStorage.getItem("WONum");
        console.log("TECHVALUT", this.state.TechVaultVisible);
        const { t } = this.props;
        //**************NEW*******wal-158***
        let supcount = JSON.parse(localStorage.getItem("PFSuppCount"));
        let catcount = JSON.parse(localStorage.getItem("PFCatCount"));
        let mfgcount = this.state.MFGSelectedCount
        let pickupchk = localStorage.getItem("pickupcheck") != null ? JSON.parse(localStorage.getItem("pickupcheck")) : false
        let invenchk = localStorage.getItem("inventorycheck") != null ? JSON.parse(localStorage.getItem("inventorycheck")) : false
        if (catcount > 0) {
            $("#supplierDIVid").addClass("disabledbutton");
        }
        else {
            $("#supplierDIVid").removeClass("disabledbutton");
        }
        if (supcount > 0) {
            $("#categoryDIVid").addClass("disabledbutton");
        }
        else {
            $("#categoryDIVid").removeClass("disabledbutton");
        }

        //************END***************
        return (
            <React.Fragment>

                <div className="content-section-title mobile-header-label container-fluid home-page-margin">
                    <div className="row">
                        {this.state.displayText ?
                            <div className="col-md-12 mt-2 text-center">
                                <div className="custom-under-maintenance d-inline-block align-center">
                                    <div className="d-flex align-items-start inner-alert-container">
                                        <img className="alert-icon" src="images/alert.svg" alt="" />
                                        <p className="m-0" id="OutageMsg"></p>
                                    </div>
                                </div>
                            </div> : null}

                        <div className="col-md-12">
                            <h5 className="py-3 title-txt"><Trans>Catalog Search</Trans> </h5>
                        </div>
                        {/*********NEW************/}
                        <div className="col-sm-4 col-lg-3 mt-3">
                            <div id="accordion" className="accordion-container">
                                <h6 className="accordion-title mb-0"><Trans>Pre_filter</Trans></h6>
                                {/*****NEW****wal-158****/}
                                {CookieService.getLocalStorageValues("Shipment_Method", true) ?
                                    <div className=" w-100 zindex">

                                        <h5 className="search-category d-block title-font  ml-3 mt-3 mb-2" style={{ fontSize: "13px" }}><Trans>Shipment Method</Trans></h5>
                                        <label className=" custom-radiobtn ml-3 "><Trans>Pickup</Trans>
                                            <input type="radio" id="deliveryshipment" checked={this.state.pickUp} name="SHIP" onChange={() => this.pickupchange(0)} />
                                            <span className="checkmark checkmark-org" style={{ top: "3px", left: "3px" }} />
                                        </label>
                                        <label className="custom-radiobtn pb-3 mb-0"><Trans>Ship To</Trans>
                                            <input type="radio" id="pickupshipment" checked={this.state.deliveryShipTo} name="PICK" onChange={() => this.pickupchange(1)} />
                                            <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />
                                        </label>

                                        {/*/ <div className="custom-control custom-checkbox m-3 item-custom-control d-inline-block" style={{ width: "100%" }}>
                                    <input type="checkbox" className="custom-control-input" id="Pickup" checked={pickupchk} name="Pickup" onChange={e => this.pickupchange(e)} />
                                    <label className="custom-control-label priority-checkbox filter-checkbox" htmlFor="Pickup"><Trans>Pick-up suppliers</Trans></label>

                                </div>
                              //<div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block">

                                //    <input type="checkbox" className="custom-control-input" id="InventoryCheck" checked={invenchk} name="Inventory" onChange={e => this.InventoryCheck(e)} />
                                //    <label className="custom-control-label priority-checkbox filter-checkbox" htmlFor="InventoryCheck" ><Trans>inv_supplier</Trans></label>

                                //</div>*/}
                                    </div> : null}
                                {/**********END***********/}

                                <div className="card border-0 w-100 " id="categoryDIVid">
                                    <div className="card-header p-0" id="headingOne">
                                        <h5 className="mb-0 accordion-header filteraccheading open">
                                            <Trans>Category</Trans>{catcount > 0 ? catcount > 99 ? <span className="filtercnt cntalign" style={{ width: '29px', padding: '6px 4px', height: '26px' }}>99+</span> : <span className="filtercnt cntalign">{catcount}</span> : null}
                                        </h5>
                                        <span className="accordion-heading accordion-icon-position" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" onClick={() => this.fetchPrefilterData("TradeCatalog", '')} />
                                    </div>
                                    <div id="collapseOne" className="collapse " aria-labelledby="headingOne" data-parent="#accordion">
                                        <div className="card-body m-0 p-0 filteracc-body" id="child1">
                                            {this.state.PFCategory && this.state.PFCategory.length > 0 ?
                                                <div className="col-md-12 search-container">
                                                    <div className="w-100 input-group ">
                                                        <input type="text" className="form-control pr-5" placeholder={t('Search')} id="categoryid" name="catsearch" aria-label="Text input with dropdown button" onChange={() => this.closeicon("CAT")} />
                                                        <span className="dropdown-search-icon" onClick={this.categorysearch} />
                                                        <span className="search-closeicon d-none" id="catclose" onClick={() => this.cleariconclick("CAT")}>x</span>
                                                    </div>
                                                </div> : null}
                                            <div className="col-md-12">
                                                <div className="row">
                                                    {/**WW-633_PC_10 (2/24/2023) -Aparna*/}
                                                    {this.state.viewcat == false && CategoryPresent == true ? <div className="col-md-7 px-1">
                                                        <a className="filterlink p-0" onClick={() => this.selectall('CAT')} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>{this.state.selectallCat == true ? "Select All" : "Unselect All"}</Trans></a>
                                                    </div> : null}
                                                    {catcount == null || catcount == 0 ? null : <div className="col-md-7 px-0">
                                                        <a className="filterlink p-0" onClick={() => this.viewcat()} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>{this.state.viewcat == true ? 'Refresh' : 'View My Selection'}</Trans></a>
                                                    </div>}
                                                    {this.state.selectallCat == true && catcount != null && catcount != 0 || (this.state.viewcat == true && catcount) ? <div className="col-md-4 col-4 col-sm-4 col-lg-4 ml-4  text-right">
                                                        <a className="filterlink p-0" onClick={() => this.CatClearClick("CAT")} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>Clear</Trans></a>

                                                    </div> : null}
                                                </div>
                                            </div>


                                            {/* <a href="#" className="filterlink d-none">Select All</a> <a href="#" className="filterlink">Unselect All</a>*/}
                                            <div className="col-md-12 p-0 catalogfilter-container">
                                                {this.state.PFCategory && this.state.PFCategory.length > 0 ?
                                                    this.CategoryBind()
                                                    :
                                                    <div className="loading-container">
                                                        <RotatingLines
                                                            strokeColor="#fdb813"
                                                            strokeWidth="5"
                                                            animationDuration="0.75"
                                                            width="50"
                                                            visible={true}
                                                        />
                                                    </div>
                                                }

                                            </div>
                                            {/*<div className="col-md-12 search-container filteracc-body">
                                            <div className="w-100 input-group  ">
                                                <button className="btn btn-primary custom-btn-secondary mrg-rgh " onClick={()=>this.CatClearClick("CAT")} >
                                                    Clear</button>                                               
                                           </div>
                                        </div>*/}
                                        </div>
                                    </div>
                                </div>
                                <div className="card border-0" id="supplierDIVid">
                                    <div className="card-header p-0" id="headingTwo">
                                        <h5 className="mb-0 accordion-header filteraccheading">
                                            <Trans>Supplier</Trans> {supcount > 0 ? supcount > 99 ? <span className="filtercnt cntalign" style={{ width: '29px', padding: '6px 4px', height: '26px' }}>99+</span> : <span className="filtercnt" >{supcount}</span> : null}
                                        </h5>
                                        <span className="accordion-heading accordion-icon-position" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseOne" onClick={() => this.fetchPrefilterData("Supplier", '')} />
                                    </div>
                                    <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                        <div className="card-body m-0 p-0 filteracc-body" id="child2">
                                            <div className="col-md-12 search-container ">
                                                {this.state.PFSupplier && this.state.PFSupplier.length > 0 ?
                                                    <div className="w-100 input-group">
                                                        <input type="text" className="form-control pr-5" id="supplierid" placeholder={t('Search')} aria-label="Text input with dropdown button" onChange={() => this.closeicon("SUP")} />
                                                        <span className="dropdown-search-icon" onClick={this.suppliersearch} />
                                                        <span className="search-closeicon d-none" id="supclose" onClick={() => this.cleariconclick("SUP")}>x</span>
                                                    </div> : null}
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row">
                                                    {/**WW-633_PC_10 (2/24/2023) -Aparna*/}
                                                    {this.state.viewsup == false && supplierPresent == true ? <div className="col-md-7 col-7 px-1">
                                                        <a className="filterlink p-0" onClick={() => this.selectall('SUP')} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>{this.state.selectallSup == true ? "Select All" : "Unselect All"}</Trans></a>
                                                    </div> : null}
                                                    {supcount == null || supcount == 0 ? null : <div className="col-md-7 col-7 px-0">
                                                        <a className="filterlink p-0" onClick={() => this.viewselectionSup()} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>{this.state.viewsup == true ? 'Refresh' : 'View My Selection'}</Trans></a>
                                                    </div>}
                                                    {this.state.selectallSup == true && supcount != null && supcount != 0 || (this.state.viewsup == true && supcount > 0) ? <div className="col-md-4 col-4 col-sm-4 col-lg-4 ml-4 text-right">
                                                        <a className="filterlink p-0" onClick={() => this.CatClearClick("SUP")} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>Clear</Trans></a>

                                                    </div> : null}
                                                </div>
                                            </div>
                                            {/*<div className="col-md-12">
                                        <a className="filterlink" onClick={() => this.selectall('SUP')} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}> {this.state.selectallSup == true ? 'Select All' : 'UnSelect All'}</a>
                                        <a className="filterlink" onClick={() => this.viewselectionSup()} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}>{this.state.viewsup == true ? 'Refresh' : 'View My Selection'}</a>
                                            <a className="filterlink" onClick={() => this.CatClearClick("SUP")} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>clear</Trans></a>
                                            </div>*/}
                                            {/*<a href="#" className="filterlink">Select All</a> <a href="#" className="filterlink d-none">Unselect All</a>*/}
                                            <div className="col-md-12 p-0 catalogfilter-container">
                                                {this.state.PFSupplier && this.state.PFSupplier.length > 0 ? (
                                                    this.SupplierBind()
                                                ) : (

                                                    <div className="loading-container">
                                                        <RotatingLines
                                                            strokeColor="#fdb813"
                                                            strokeWidth="5"
                                                            animationDuration="0.75"
                                                            width="50"
                                                            visible={true}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                            {/*<div className="col-md-12 search-container filteracc-body">
                                            <div className="w-100 input-group  ">
                                                <button className="btn btn-primary custom-btn-secondary mrg-rgh " onClick={() => this.CatClearClick("SUP")} >
                                                    Clear</button>
                                            </div>
                                        </div>*/}
                                        </div>
                                    </div>
                                </div>
                                <div className="card border-0" >
                                    <div className="card-header p-0" id="headingThree">
                                        <h5 className="mb-0 accordion-header filteraccheading" data-enabled="false" id="EditAccdordian">
                                            <Trans>Manufacturer</Trans> {mfgcount > 0 ? mfgcount > 99 ? <span className="filtercnt cntalign" style={{ width: '29px', padding: '6px 4px', height: '26px' }}>99+</span> : <span className="filtercnt cntalign">{mfgcount}</span> : null}
                                        </h5>
                                        <span className="accordion-heading accordion-icon-position" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseOne" />
                                    </div>
                                    <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                        <div className="card-body m-0 p-0 filteracc-body " id="child3">
                                            <div className="col-md-12 search-container">
                                                <div className="w-100 input-group">
                                                    <input type="text" className="form-control pr-5" placeholder={t('Search')} name="getMFG" id="getMFG" aria-label="Text input with dropdown button" onChange={() => this.closeicon("MFG")} />
                                                    <span className="dropdown-search-icon" onClick={this.getMFGList} />
                                                    <span className="search-closeicon d-none" id="manuclose" onClick={() => this.cleariconclick("MFG")}>x</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="row pb-3">
                                                    {/**WW-633_PC_10 (2/24/2023) -Aparna*/}
                                                    {this.state.viewmfg == false && this.state.MFGArray.length > 0 ? <div className="col-md-7 col-7 px-1">
                                                        <a className="filterlink p-0" onClick={() => this.SelectAllMfg()} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>{this.state.selectallMfg == true ? "Select All" : "Unselect All"}</Trans></a>
                                                    </div> : null}
                                                    {mfgcount == null || mfgcount == 0 ? null :
                                                        <div className="col-md-8 col-8 col-sm-8 col-lg-8 px-0">
                                                            {/* <a href="#" className="filterlink d-none">Select All</a> <a href="#" className="filterlink d-none"><Trans>deselect_all</Trans></a>*/}

                                                            <a className="filterlink pl-0" onClick={() => this.viewselectedmfg()} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>{this.state.viewmfg == true ? 'Refresh' : 'View My Selection'}</Trans></a>
                                                        </div>
                                                    }
                                                    {/*  <a className="filterlink" onClick={() => this.CatClearClick("MFG")} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>clear</Trans></a>*/}
                                                    {this.state.selectallMfg == true && mfgcount != null && mfgcount != 0 || (this.state.viewmfg == true && this.state.ViewMfgList.length > 0) ? <div className="col-md-4 col-4 col-sm-4 col-lg-4 text-right">
                                                        <a className="filterlink p-0" onClick={() => this.ClearMfg("MFG")} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}><Trans>Clear</Trans></a>
                                                    </div> : null}
                                                </div>
                                            </div>
                                            <div className="col-md-12 p-0 catalogfilter-container">
                                                {!this.state.ViewMfgList ? (
                                                    <div className="loading-container">
                                                        <RotatingLines
                                                            strokeColor="#fdb813"
                                                            strokeWidth="5"
                                                            animationDuration="0.75"
                                                            width="50"
                                                            visible={true}
                                                        />
                                                    </div>
                                                ) : (
                                                    this.PFManufacturerBind()
                                                )}
                                            </div>
                                            {/* <div className="col-md-12 search-container filteracc-body">
                                            <div className="w-100 input-group  ">
                                                <button className="btn btn-primary custom-btn-secondary mrg-rgh " onClick={() => this.CatClearClick("MFG")} >
                                                    Clear</button>
                                            </div>
                                        </div>*/}
                                        </div>
                                    </div>
                                </div>

                                {/*****NEW****wal-158****/}
                                {/*<div className="card-header custom-card-reset card-custom-padding zindex">
                                <div className="custom-control custom-checkbox my-2 item-custom-control d-inline-block">
                                    <input type="checkbox" className="custom-control-input" id="Pickup" checked={pickupchk} name="Pickup" onChange={e => this.pickupchange(e)} />{/*NEW*** (1/25/20201)**CHANGED***(id)** customCheck9--> customCheckInfo***/}
                                {/* <label className="custom-control-label priority-checkbox filter-checkbox" htmlFor="Pickup">WLL-CALL SUPPLIERS </label>{/*NEW*** (1/25/20201)**CHANGED***(htmlfor)** customCheck9--> customCheckInfo***/}
                                {/* </div>
                            </div>
                            {/**********END***********/}
                            </div>
                        </div>

                        {/********END***************/}

                        <div className="col-sm-8 col-lg-6 center-panel mt-5">


                            {/* WW-1336 Relevant type ahead suggestions - 3/14/2025 - Surya K*/}
                            <div className="col-md-12 col-lg-10 mx-auto p-0 search-autocomplete home-search" ref={this.wrapperRef}>

                                <div className="input-group dropdown-search mr-2 mb-2">
                                    <div className="input-group-prepend">
                                        <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" id="filterButton" aria-expanded="false" ><Trans>{this.state.SearchType}</Trans></button>
                                        <div className="dropdown-menu">
                                            <a
                                                className="dropdown-item"
                                                onClick={() => this.OnClickSearchType("All")}
                                            >
                                                <Trans>All</Trans>
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                onClick={() => this.OnClickSearchType("Sup P.#")}
                                            >
                                                <Trans>Supplier Part #</Trans>
                                            </a>
                                            <a
                                                className="dropdown-item"
                                                onClick={() => this.OnClickSearchType("MFG P.#")}
                                            >
                                                <Trans>Manufacturer Part #</Trans>
                                            </a>
                                        </div>
                                    </div>
                                    <input type="text" className="form-control" placeholder="Search" id="searchTxt" aria-label="Text input with dropdown button" value={this.state.autoCompleteValue} onChange={(e) => this.onChange(e)} onKeyDown={(e) => this.searchKeyPress(e)} onFocus={() => { this.handleShowElement() }} ref={this.inputRef} />
                                    {this.state.autoCompleteValue.trim().length > 0 && this.state.elementIsShow ? this.displaySuggestions() : null}
                                    <span className={this.state.autoCompleteValue.length > 0 ? "search-cancel-home cursor-pointer" : "d-none"} onClick={() => this.clearSearch()}></span>
                                    <span className="dropdown-search-icon" id="searchIcon" onClick={() => { this.searchClick("Global") }} />
                                    <img
                                        className="custom-file-attach-icon" src="Images/capture_icon_black.svg"
                                        alt="Select File"
                                        onClick={this.handleImageClick}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <input
                                        type="file"
                                        title=" "
                                        ref={this.fileInputRef}
                                        id="ImageFile" name="ImgClick"
                                        accept="image/jpeg, image/png"
                                        style={{ display: 'none' }}
                                        onChange={this.handleFileChange}


                                    />



                                </div>

                                <div className="work-order-switcher d-flex">
                                    <div className="form-check form-switch d-flex align-items-center me-4 mt-1 mr-1 form-check-home ">
                                        <label className="switch">
                                            <input type="checkbox" className="cust-toggle"
                                                onChange={(e) => this.onChangePC(e)}
                                                checked={this.state.IsProblemCodeSearch} />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                    <span>Suggested item(s) for the work order</span>
                                </div>

                                {/*<Autocomplete
                                id="searchid"
                                getItemValue={this.getItemValue}
                                items={this.state.autocompleteData}
                                renderItem={this.renderItem}
                                value={this.state.autoCompleteValue}
                                onChange={this.onChange}
                                onSelect={this.onSelect}
                                inputProps={{ placeholder: "Search", className: "search-lg float-left", onKeyDown: this.searchKeyPress }}

                            />*/}


                                {/***********NEW******wal-158******
                                <div className="col-md-11 mx-auto p-0 search-autocomplete home-search">
                                <div className="custom-control custom-checkbox my-3 ml-3 item-custom-control custcheck float-left">                                  
                                <input type="checkbox" className="custom-control-input" id="Pickup" name="Pickup" checked={pickupchk} onChange={e => this.pickupchange(e)} />
                                <label className="custom-control-label priority-checkbox filter-checkbox" htmlFor="Pickup">WLL-CALL SUPPLIERS </label>
                            </div>
                </div> ******END***********/}


                                {/*<div className="row justify-content-center">
                            <div className="col-md-10 mb-5 mt-5">
                                <select className="form-control" onChange={this.referenceSiteChange} value={this.state.referenceSite}>
                                    <option value="">{t("Reference Site")}</option>

                                    <option value="https://one.walmart.com/content/facilities-management/outsource/TI/MTI.html">{t("Tech Hub")}</option>{/*WW-243 Tech hub link is broken - Deepthi N H
                                    <option value="https://www.sdi.com/walmart-tech-reference">{t("Tech Reference")}</option>
                                    < option value="http://walmartnavigator.dhpace.com/" > {t("Door - DH Pace")}</option>
                                    <option value="https://www.coatsgarage.com/parts-lists" > {t("Lift Truck - Coats Garage")}</option>
                                    <option value="https://login.lifttrucksolutions.com/" > {t("Lift Truck - Wiese")}</option>
                                    <option value="https://store.hgmforkliftparts.com/" > {t("Lift Truck - HGM Liftparts")}</option>
                                </select>
                                <a href="#" className="dropdown-link-home" target="_blank" onClick={this.referenceSiteNavigation}>{this.state.referenceSite}</a>
                            </div>
                        </div>*/}

                                <div className="row justify-content-center w-100">
                                    {/*WW-1229 Home tiles -Nandhini L*/}
                                    <div className="col-md-8 mt-4 target-drop-home">
                                        <span style={{ "fontSize": "12px" }}><Select
                                            id="refSiteid"
                                            name="refSiteDD"
                                            style={{ "width": "80px" }}
                                            onChange={(e) => this.referenceSiteChange(e)}
                                            value={{ label: t(this.state.siteName) }}
                                            defaultValue={t("Reference Site")}
                                            options={this.state.RefsiteOptions}
                                        /></span>

                                        {/*<a href="#" className="dropdown-link-home" target="_blank" onClick={this.referenceSiteNavigation}>{this.state.referenceSite.length > 55 ? this.state.referenceSite.substring(0, 55) + "..." : this.state.referenceSite}</a >*/}
                                        {/**A1QA-112 BUG (1/3/2023)-Aparna*/}
                                        <label className="dropdown-link-home" style={{ color: "#007bff", cursor: "Pointer" }} onClick={(e) => this.referenceSiteNavigation(e, this.state.referenceSite)}>{this.state.referenceSite.length > 55 ? this.state.referenceSite.substring(0, 55) + "..." : this.state.referenceSite}</label >
                                    </div>
                                </div>
                                <div className="modal userid Home-WO" id="WorkOrderPopUpHome" data-backdrop="static" data-keyboard="false" >
                                    <div className="modal-dialog home-wo-input custom-popup modal-dialog-centered">
                                        <div className="modal-content">
                                            {/* Modal Header */}
                                            <div className="modal-header">
                                                <h4 className="modal-title mt-1"><Trans>Work order #</Trans></h4>
                                                <button type="button" className="btn close-btn" data-dismiss="modal" onClick={() => this.WOClose()}>
                                                    X
                                                </button>
                                            </div>
                                            {/* Modal body */}
                                            <div className="modal-body">
                                                <div className="row justify-content-center">
                                                    <div className="col-md-11 my-3">
                                                        <div className="row">
                                                            <label className="confirm-content d-block ml-3"><Trans>Please enter a WO# to continue</Trans></label>
                                                            <div className="col-lg-12 col-md-12 input-group charge-code-group float-left ">
                                                                <input type="text" className={`form-control charge-code-control`} placeholder={t("Enter WO#")} id="WONUMHOME" maxLength="9" onKeyDown={this.KeyPress} pattern="[0-9]*" value={this.state.WONum} onChange={this.WONumChange} defaultValue={''} />

                                                                {this.state.WONum != undefined && this.state.WONum != null && this.state.WONum != "" && this.state.WONum != " " ?
                                                                    < span className="search-cancel-header cursor-pointer" style={{ right: "58px" }} onClick={() => this.ClearWO()}  > </span> : null
                                                                }
                                                                <div className="input-group-append" >
                                                                    <span className="input-group-text" onClick={() => this.ValidateWO()} >
                                                                        <span className="shopping-search-icon" />
                                                                    </span>
                                                                </div>
                                                                {this.state.WOErrorMsg.length > 0 ? <span className="errorspan12 text-left my-2" id="StatusMsgbilltostore">{this.state.WOErrorMsg}</span> : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className=" modal modal-shipment-method" id="Delivery_Method" data-backdrop="static" data-keyboard="false" aria-modal="true">
                                    <div className="modal-dialog  modal-md custom-popup modal-dialog-centered">
                                        <div className="modal-content" style={{ width: "88%" }}>

                                            <div className="modal-header">
                                                <h4 className="modal-title mt-1"><Trans>Search Criteria</Trans></h4>
                                                <button type="button" className="btn" data-dismiss="modal" style={{padding: "0px 8px"}} onClick={() => this.state.IsProblemCodeSearch ? this.PcPopupBtnClick("Cancel") : this.shpCloseClk()}>
                                                    X
                                                </button>
                                            </div>

                                            {/* Modal Header */}
                                            <div className=" modal-title mt-3 modal-shippingmethod-header">
                                                <h4 className="modal-title shipmehtod-title mt-1 ml-3" style={{ display: "inline" }}><Trans>Shipment Method</Trans></h4>
                                            </div>
                                            {/* Modal body */}

                                            <div className="modal-body  pt-0">
                                                <div className="col-12 p-0 mt-2">
                                                    <label className="custom-radiobtn pb-3 mb-0 mr-4"><Trans>Pickup</Trans>

                                                        <input type="radio" id="pickup1" checked={this.state.pickUp} name="ship2" onChange={() => this.pickupchange(0)} />
                                                        <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />
                                                    </label>
                                                    <label className="custom-radiobtn pb-3 mb-0 mr-4"><Trans>Ship To</Trans>
                                                        <input type="radio" id="deliveryshiptoId" checked={this.state.deliveryShipTo} name="pick21" onChange={() => this.pickupchange(1)} />

                                                        <span className="checkmark checkmark-org" style={{ top: "2px", left: "2px" }} />

                                                    </label>
                                                    <div>
                                                        {this.state.IsProblemCodeSearch ?
                                                            <div className="row">
                                                                <label className="modal-title shipmehtod-title mt-1 mr-2 mb-3 ml-3">Work order # </label>   <span className="color-manditory mr-1"> *</span>
                                                                <div className="col-lg-12 col-md-12 input-group charge-code-group float-left ">
                                                                    <input type="text" className={`form-control charge-code-control ${woNum ? 'disabled' : "" }`} placeholder="Enter WO#" id="WONUMHOME" maxLength="9" onKeyDown={this.KeyPress} pattern="[0-9]*" value={this.state.WONum} onChange={this.WONumChange} defaultValue={''} />

                                                                    {this.state.WONum != undefined && this.state.WONum != null && this.state.WONum != "" && this.state.WONum != " " ?
                                                                        < span className="search-cancel-header cursor-pointer" style={{ right: "58px" }} onClick={() => this.ClearWO()}  > </span> : null
                                                                    }
                                                                    <div className="input-group-append" >
                                                                        <span className="input-group-text" onClick={() => this.ValidateWO()} >
                                                                            <span className="home-search-icon" />
                                                                        </span>
                                                                    </div>
                                                                    {this.state.WOErrorMsg.length > 0 ? <span className="errorspan12 text-left my-2" id="StatusMsgbilltostore">{this.state.WOErrorMsg}</span> : null}
                                                                </div>
                                                            </div> : null}

                                                        <div className="d-flex shiment-info">
                                                            <span className="mt-1">
                                                                <img className="mr-2 " src="images/PO-Info.svg" /></span>


                                                            {this.state.IsProblemCodeSearch ?
                                                                <label className="confirm-content shipment-font"><Trans>{`Search results will depend on your chosen shipment method and the work order #`}</Trans></label>
                                                                :
                                                                <label className="confirm-content shipment-font"><Trans>{`Search results will be based on your selection`}</Trans></label>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <span id="shipmentmethoderrorid" className="DropDown-Font-Size errorcolour"></span>

                                                <div className="col-md-12 mt-2 text-right p-0">
                                                    {this.state.IsProblemCodeSearch ? (
                                                        <>
                                                            <button
                                                                className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-3 mt-3"
                                                                data-dismiss="modal"
                                                                onClick={() => this.PcPopupBtnClick("Cancel")}
                                                            >
                                                                <Trans>Cancel</Trans>
                                                            </button>
                                                            <button
                                                                className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3"
                                                                id="subdecbtn"
                                                                onClick={() => this.PcPopupBtnClick("Apply")}
                                                                disabled={this.state.WONum.length <= 0}
                                                                onKeyDown={this.searchKeyPress}
                                                            >
                                                                <Trans>Apply</Trans>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button
                                                                className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-3 mt-3"
                                                                data-dismiss="modal"
                                                                onClick={() => this.shpCloseClk()}
                                                            >
                                                                <Trans>Cancel</Trans>
                                                            </button>
                                                            <button
                                                                className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3"
                                                                id="subdecbtn"
                                                                onClick={() => this.searchClick("Shipment Method")}
                                                                onKeyDown={this.searchKeyPress}
                                                            >
                                                                <Trans>Apply</Trans>
                                                            </button>
                                                        </>
                                                    )}

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*WW-1229 Home tiles -Nandhini L*/}
                                {this.state.UserTiles.length > 0 ?
                                    <div className="col-md-12 float-left p-0">
                                        {this.BindHomeTiles()}
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>

            </React.Fragment>);

    };

};
export default withTranslation()(HomePageComponent);




